(function() {
  "use strict";

  angular.module("sempraWebapp").constant("nlTranslations", {
    MESSAGE:"Bericht",
    ERROR_TITLE:"Fout",
    ERROR_MESSAGE:"Er is een fout opgetreden bij het uitvoeren van de functie. ",
    ERROR_LOGIN:"Er is een fout opgetreden tijdens login. Het opgegeven email adres is niet geldig.",
    ERROR_LOGIN_ROLE:"Rol voor huidig applicatiemerk is niet geldig",
    OK:"OK",
    CANCEL:"Annuler ",
    YES:"Ja",
    NO:"Néé ",
    FROM:"Van",
    TO:"Tot",
    DELETE:"Verwijderen ",
    SIGN_OUT:"Log uit",
    NAME:"Naam",
    DATE:"Datum",
    PIECES:"Aantal ",
    HOURS:"uren",
    DAYS:"Dagen",
    MONTH:"Maand",
    MONTHS:"Maanden ",
    YEAR:"Jaar",
    BOX:"Box",
    SEARCH:"Zoek",
    ALL_USERS:"Alle gebruikers ",
    ARE_YOU_SURE:"Weet U zéker?",
    BACK:"Terug",
    AMOUNT:"Bedrag",
    DESCRIPTION:"Omschrijving ",
    FORGOT_PASSWORD_ERROR_MSG:"Er is een fout opgetreden. Controleer uw email adres en probeer het opnieuw.",
    REQUIRED_FIELD:"Verplichte veld",
    LOGOUT_TITLE:"Weet U zéker dat u wilt uitloggen?",
    LOGOUT_MSG:"Alle niet-opgeslagen gegevent gaat u kwijt raken?",
    ACTIVATION_ACCOUNT:"U account was met succes geactiveerd",
    UNKNOWN_ERRROR_NOTIFICATION:"Onebekende fout is opgetreden",
    CONTINUE:"Door gaan",
    DATA_NOT_AVAILABLE:"Gegevens  zijn niet beschikbaar.",
    SELECT:"Selecteer ",
    SELECT_CURRENCY:"Selecteer valuta",
    UPLOAD:"Uploaden",
    PHONE:"Telefoon",
    WEBSITE:"Web pagina",
    WORKING_HOURS:"Openingstijden",
    INSERT:"Invoegen",
    TEXT:"Tekst",
    CREATED:"Gemaakt",
    VALID_UNTIL:"Geldig tot en met",
    SAVE:"Opslaan",
    TOKENS:"Munten",
    DELETE_COMPANY_HISTORY:"Bedrijfsgeschiedenis verwijderen?",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"Geschiedenis verwijdert",
    HELP:"Hulp",
    VALUE:"Waarde",
    ACTIVATING_ACCOUNT_ERROR:"Er is een probleem met activatie van uw R2W account. Probeer het opnieuw alstublieft.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Welkom bij Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Welkom bij R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Voer uw nieuwe wachtwoord en bevestig alstublieft om uw R2W account te activeren. U wordt automatisch ingelogd. ",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"U kunt later uw gebruikersinstellingen in de applicatie wijzigen",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:" Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:" R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Voer uw nieuwe wachtwoord in en bevestig het om het oude wachtwoord te resetten. U wordt automatisch ingelogd in de applicatie bij succes",
    RESET_PASSWORD_WELCOME_MSG_3:"U kunt later uw gebruikersinstellingen in de applicatie wijzigen",
    ENTER_NEW_PASSWORD:"Nieuw wachtwoord invoeren",
    REPEAT_NEW_PASSWORD:"Nieuw wachtwoord herhalen ",
    PASSWORD_MIN_LENGTH:"Wachtwoord moet minstens 8 charactera lang zíjn",
    PASSWORD_MAX_LENGHT:"Wachtwoord mag niet langer dan 32 characters zijn",
    PASSWORD_PATTERN:"Wachtwoord moet minstens een hoofdletter en een klein letter bevatten",
    PASSWORD_MATCH:"Wachtwoorden komen niet overeen",
    ACTIVATE:"Actieveren",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Je verzoek is met succes ingediend. Controleer uw e-mail voor een bevestigingsbericht",
    VALIDATION_REQUIRED:"Verplichte veld",
    VALIDATION_EMAIL:"Ongeldige e-mail adres",
    VALIDATION_INTEGER_NUMBER:"Geheel getal invoeren alstublieft ",
    VALIDATION_HOURS_VALUE:"Waarde moet tussen 0-23 liggen",
    VALIDATION_MINUTES_VALUE:"Waarde moet tussen 0-59 liggen",
    VALIDATION_NOT_A_DATE:"Waarde is geen datum",
    VALIDATION_FROM:"Vanaf de datum later dan tot",
    VALIDATION_TO:"Tot de datum eerder dan vanaf",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Die vermelding bestaat al in de database",
    PASSWORD_VALIDATION_PATTERN_NEW:"Er moet minstens één cijfer, één kleine letter en één hoofdletter zijn. Witte spaties zijn niet toegestaan",
    VALIDATION_PERCENT_VALUE:"Waarde moet tussen 1-1999 liggen",
    NUMBERS_ONLY_100:"Tellende nummer tot en met 100",
    NUMBERS_ONLY_1000:"Tellende nummer tot en met 1000",
    POSITIVE_NUMBERS_ONLY:"Alleen tellende nummers",
    GRID_PAGER_PAGE:"Pagina",
    GRID_PAGER_ROWS_PER_PAGE:"Rijen per pagina",
    GRID_PAGER_PAGE_OF:"van",
    BREAD_CRUMBS_HOME:"Tuis",
    BREAD_CRUMBS_DASHBOARD_TECH:"Dashboard technologie",
    BREAD_CRUMBS_DETAILS:"Details",
    BREAD_CRUMBS_SETTINGS:"Instellingen",
    BREAD_CRUMBS_WORKING_HOURS:"Werkuren",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Verslag van totale omzet per dag",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Verslag van gemiddelde omzet per uur",
    BREAD_CRUMBS_NEW_USER_GROUP:"Gebruikers groep aanmaken",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Gebruikers groep bewerken",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Campagne sjabloon aanmaken",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Campagne sjabloon bewerken",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Campagne aanmaken",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Campagne aanmaken",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodiek overzicht",
    LOGIN:"Inloggen",
    EMAIL:"E-mail",
    PASSWORD:"Wachtwoord",
    LANGUAGE:"Taal",
    FORGOT_PASSWORD:"Wachtwoord vergeten?",
    SUBMIT:"Indienen",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Aantal alarmen in behandeling:",
    HEADER_VIEW_ALL_ALARMS:"Bekijk alle alarmen",
    HEADER_MY_ACCOUNT:"Mijn account",
    HEADER_ACCOUNT_MANAGEMENT:"Account beheer",
    ACCOUNT_ALREADY_EXIST:"Deze e-mail adres is al in gebruik",
    NEWSLETTER_CONFIRMATION:"Stuur een e-mailmelding voor de alarmstatus",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Overzicht van de dagelijkse financiën",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Dashboard Technologie",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Dashboard",
    ASIDE_MENU_ALARMS:"Berichten",
    ASIDE_MENU_FACILITIES:"Faciliteiten",
    ASIDE_MENU_REPORTS:"Raporten",
    ASIDE_MENU_REPORT:"Geselecteerd rapport",
    ASIDE_MENU_LOYALTY:"Loyaliteit",
    ASIDE_MENU_USER_GROUPS:"Gebruikers groep",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodieke overzicht",
    ASIDE_MENU_MANAGING_TOKENS:"Tokens beheren",
    ASIDE_MENU_NEWS:"Nieuws",
    DAILY_FINANCES_TOTAL_MONEY:"Totaal omzet",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Totaal omzet voor alle faciliteiten",
    DAILY_FINANCES_TOTAL_COINS:"Totaal gebruikte metalen tokens",
    DAILY_FINANCES_DOWNLOAD_CSV:"CVS downloaden",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Contant geld",
    DAILY_FINANCES_CHANGER:"Contant geld in wisselaar",
    DAILY_FINANCES_COINS:"Munten/Eurokey",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Rapport type",
    REPORTS_CHOOSE_FACILITY:"Faciliteit kiezen",
    REPORTS_PERIOD_1:"Periode 1 - ",
    REPORTS_PERIOD_2:"Periode 2 -",
    MONEY_BY_DATE_REPORT:"Totaal inkomen per datum",
    R2W_BY_DATE_REPORT:"Totaal inkomen uit R2W-munten per datum",
    COINS_BY_DATE_REPORT:"Totaal gebruikte munten per datum",
    AVG_MONEY_BY_HOUR_REPORT:"Gemiddelde inkomen per uur",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Gemiddelde inkomen per dag van de week",
    AVG_MONEY_BY_BOX_REPORT:"Uitgaven per box",
    COMPARE_PERIODS_REPORT:"Vergelijkend verslag van de faciliteit",
    TOTAL_USERS_BY_GROUP:"Totaal R2W app bezoekers per dag",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"gebruikers",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"bezoeken",
    VISITS_COUNT_REPORT:"Aantal R2W app gebruikers per bezoek",
    LOYALTY_PER_DAY_REPORT:"Aantal Lokale munten uitgegeven per dag",
    LOYALTY_PER_PAYMENT_METHOD:"Gegeven lokale munten per betaalmethode",
    VISITS:"Bezoeken",
    VISIT:"Bezoek",
    TOTAL_SPENT_MONEY:"Totaal inkomen",
    MONEY:"Geld",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Totale geld inkomen per periode",
    DOWNLOAD_CSV:"CSV downloaden",
    TOTAL_SPENT_COINS:"Totaal uitgegeven munten ",
    TOTAL_USERS:"Totaal gebruikers",
    TOTAL_CREDIT_GIVEN:"Totaal gebruikte lokale virtuele munten",
    EUROKEY_BY_DATE_REPORT:"Totaal Eurokey betalingen per datum",
    TOTAL_SPENT_EUROKEY:"Totaal uitgegeven",
    SELECT_TYPE_OF_REPORT:"U moet het type rapport selecteren",
    NUMBER_OF_VISITS_TITLE:"Aantal bezoeken ",
    NUMBER_OF_USERS_TITLE:"Aantal gebruikers",
    PIECES_TITLE:"Stukken",
    TOTAL_VISITS:"Totaal bezoeken",
    TOKENS_TITLE:"munten",
    SEARCH_USERS_NO_RESULTS:"Geen gebruikers gevonden voor opgegeven zoekterm",
    SEARCH_USERS:"Zoek gebruikers",
    SEARCH_TELEPHONES:"Zoek gebruikers per mobiele nummer",
    ADD_USER_TO_GROUP:"Gebruiker aan groep toevoegen",
    REMOVE_USER_FROM_GROUP:"Gebruiker uit groep verwijderen",
    USER_GROUP_NAME_REQUIRED:"Naam gebruikersgroep is vereist",
    USER_GROUP_NAME:"Gebruikersgroep naam",
    USER_GROUPS_OVERVIEW:"Gebruikersgroep overzicht",
    USER_COUNT:"Aantal gebruikers",
    NEW_USER_GROUP:"Nieuwe gebruikersgroep aanmaken",
    DELETE_USER_GROUP:"Gebruikersgroep verwijderen",
    UPDATE_USER_GROUP:"Gebruikersgroep bewerken",
    DELETE_USER_GROUP_ERROR:"Er is een fout opgetreden bij het verwijderen van de geselecteerde gebruikersgroep. Probeer het opnieuw of neem contact op met ondersteuning ...",
    CONFIRM_DELETE_USER_GROUP:"Weet u zeker dat u de geselecteerde gebruikersgroep wilt verwijderen?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Loyaliteitsacties waaraan de verwijderde groep is toegewezen, worden niet meer toegepast.",
    GROUP_NAME_MAX_LENGTH:"De groepsnaam mag niet langer zijn dan 255 tekens",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Gebruiker is al in deze groep",
    MISSING_USER:"Ontbrekende gebruiker",
    USER_NOT_ON_LIST:"Gebruiker staat niet in de lijst met actieve gebruikers. Controleer of het e-mailadres geldig is en probeer het opnieuw.",
    UPLOAD_USER_GROUP:"Upload gebruikersgroeplijst vanuit * .csv-bestand",
    UKNOWN_USERS:"Lijst van onbekende gebruikers",
    CAMPAIGN_TEMPLATE_RULE:"Sjabloon regel",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Er is een fout opgetreden bij het verwijderen van de campagnesjabloon. Probeer het opnieuw of neem contact op met ondersteuning ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Weet u zeker dat u de geselecteerde campagnesjabloon wilt verwijderen",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Weet u zeker dat u de geselecteerde campagnesjabloon wilt verwijderen",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Campagnesjabloon overzicht",
    DELETE_CAMPAIGN_TEMPLATE:"Campagnesjabloon verwijderen",
    UPDATE_CAMPAIGN_TEMPLATE:"Campagnesjabloon bewerken",
    CREATE_CAMPAIGN_TEMPLATE:"Nieuwe campagnesjabloon aanmaken",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Naam van campagnesjabloon is vereist",
    CAMPAIGN_TEMPLATE_NAME:"Campagnesjabloon naam",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Verplichte veld",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"geef %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"extra tijd",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Selecteer type als eerst alstublieft. Wasboxen of Kleine machines",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Sjabloon regel verwijderen",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Van",
    CAMPAIGN_TEMPLATE_RULE_TO:"tot",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"uren",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuten",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nieuwe regel per aantal bezoeken",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nieuwe regel per aantal munten uitgegeven",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nieuwe regel per dag van de week",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Nieuwe sjabloon regel",
    CAMPAIGN_TEMPLATE_RULE_1:"Ieder",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Ieder",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"munten uitgegeven in minder dan",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"bezoeken in minder dan",
    CAMPAIGN_TEMPLATE_RULE_3:"dagen",
    CAMPAIGN_TEMPLATE_RULE_4:"munten",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Regellijst is leeg.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum kan niet in het verleden liggen",
    DELETE_CAMPAIGN_ERROR:"Er is een fout opgetreden bij het verwijderen van de campagne. Probeer het opnieuw of neem contact op met ondersteuning ...",
    CONFIRM_DELETE_CAMPAIGN:"Weet u zeker dat u de geselecteerde campagne wilt verwijderen?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W is niet verantwoordelijk voor de gebruikerservaring die door deze actie wordt veroorzaakt.",
    CAMPAIGNS_OVERVIEW:"Campagnes overzicht",
    DELETE_CAMPAIGN:"Campagne verwijderen",
    UPDATE_CAMPAIGN:"Campagne bewerken",
    CREATE_CAMPAIGN:"Nieuwe campagne aanmaken",
    CAMPAIGN_ACTIVE:"Actief",
    CAMPAIGN_TEMPLATE:"Sjabloon",
    CAMPAIGN_GROUPS:"Groepen",
    CAMPAIGN_ALL_USERS:"Alle gebruikers",
    CAMPAIGN_NAME:"Campagnenaam",
    CAMPAIGN_NAME_REQUIRED:"Verplicht",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Aantal gebruikers nabij drempel per dag",
    MESSAGE_TO_USERS:"Bericht aan gefilterde gebruikers",
    SEND_MESSAGE:"Bericht sturen",
    THRESHOLD:"Drempel",
    TYPE:"Type",
    TOTAL_MONEY_SPENT:"Totaal geld besteed aan campagne",
    NUMBER_OF_VISITS:"Aantal bezoeken in campagne",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Bericht minimaal 10 tekens lang zijn",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Bericht moet minder dan 350 tekens lang zijn",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Bericht tekst is verplicht",
    TECHNOLOGY:"Technologie",
    TAP_WATER:"Kraan water",
    REVERSE_OSMOSIS:"Omgekeerde osmose",
    SOFTENED_WATER:"Onthard water",
    DOSER:"Doser",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Laatste synchronisatie",
    NO_OF_CURRENT_ALARMS:"Aantal huidige alarmen",
    NO_OF_CURRENT_WARNINGS:"Aantal huidige waarschuwingen",
    WEATHER:"Het weer",
    BOXES_WORK_HOURS_COUNTERS:"Openingstijden boxen",
    BOX_TOTAL_HOURS:"Totaal openingstijden ",
    BOX_SERVICE_HOURS:"Totaal openingstijden (dienst)",
    BOX_COUNTER_HOURS:"uren",
    ALARMS_AND_WARNINGS:"Alarmen & waarschuwingen",
    FILTER_AND_BOILER:"Filter & ketel",
    FILTER_TOTAL_DAYS:"Filter werk dagen",
    BOILER_TOTAL_DAYS:"Ketel werk dagen",
    DAYS_UNIT:"dagen",
    SOFTENER:"Verzachter",
    MANUAL_COLD_DRAIN:"Handmatige koude afvoer",
    EL_COLD:"El. koud",
    DRAIN:"afvoer",
    TAP:"kraan",
    WASTE:"Verspilling",
    OSMOSIS:"osmosis",
    DEMI_WATER:"Demi water",
    EL_RINSE:"El. m. afspoelling",
    BOILER:"Ketel",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"Vloer verwarming",
    DOSER_TANK:"Doseertank",
    EL_WASH:"El. m. afwas",
    DETERGENT:"Afwasmiddel",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Update-instellingen",
    GENERAL_SETTINGS:"Algemene instellingen",
    LIGHTS:"Lichten",
    GROUPS:"Groepen",
    ANTI_FREEZE:"Antivries",
    AUTO:"Auto",
    MANUAL:"Handmatig",
    ON:"Aan",
    OFF:"Uit",
    TEMPERATURE:"Temperatuur",
    UPDATE_DEVICE:"Faciliteiten instellingen bijwerken",
    BOX_CLEAN_HOURS:"Box schoon toonbank",
    GROUP_COUNTERS:"Group toonbank",
    RESET:"Opnieuw instellen",
    CASH_COUNT:"Aantal munten",
    COINS_COUNT:"Aantal tokens",
    EUROKEY_COUNT:"Aantal Eurokeys",
    DOSER_WORK:"Doseer dienst duur (seconden)",
    DOSER_PAUSE:"Doseer pauze tijd (seconden)",
    DELAY_BFV:"BFV vertraging (ms)",
    DELAY_6M1:"6M1 vertraging (ms)",
    DELAY_LPS:"LPS vertraging (ms)",
    RESET_CASH_COUNT_ALL:"Alle munten tellers opnieuw instellen",
    RESET_COINS_COUNT_ALL:"Alle token tellers opnieuw instellen",
    RESET_EUROKEY_COUNT_ALL:"Alle Eurokey tellers opnieuw instellen",
    FACILITY_DETAILS:"Faciliteit details",
    FACILITY_NAME:"Naam faciliteit",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uw afbeelding is met succes geüpload",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uw gegevens zijn met succes geüpload",
    CONNECTED:"Verbonden",
    DISCONNECTED:"Verbinding verbroken",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Berichten filter",
    FACILITY:"Faciliteit",
    APPLY:"Toepassen",
    TIME:"Tijd",
    LOCATION:"Locatie",
    ACKNOWLEDGED:"Erkend",
    FILTERED_MESSAGES:"Gefilterde berichten",
    ACK:"Erkend",
    NOT_ACK:"Niet erkend",
    ALL:"Alle",
    ALL_FACILITIES:"Alle faciliteiten",
    ENTER_DATE_PLACEHOLDER:"Datum invoeren",
    OP_NESTANAK_NAPONA:"Ontbrekende spanning op fase-indicator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"De zekering van de hogedrukpomp is gevallen",
    OP_UPR_NAPON_24VAC_GRE:"Ontbrekende 24VAC - zekering 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Watertank leeg",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Hoofd waterpomp zekering is uitgevallen",
    OP_MIN_NIVO_OMEKS_VODE:"Verzachte watertank is leeg",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Verzachte waterpomp zekering is uitgevallen",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosis watertank is leeg",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosis watertank zekering is uitgevallen",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosis productiepomp zekering is uitgevallen",
    OP_BOJLER_GRESKA_MZS:"Ketel fout melding",
    OP_CRPKA_PRASKA_GRE_MZS:"Heet water zekering is uitgevallen",
    OP_DOZATOR_PRASKA_GRE_MZS:"Poeder doseer motor  zekering is uitgevallen",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Poeder doseer vibratoor zekering is uitgevallen",
    OP_MIN_PRASAK_TON_ALARM:"Poedermengtank leeg",
    OP_USIS_KOV_TURBINA_GRESKA:"Munt stofzuiger turbine zekering is uitgevallen",
    OP_FILTER_VODE_ZACEPLJEN:"Waterfilter verstopt ",
    OP_VISKTL_RESET_SATI_RADA:"Hogedrukpomp servies",
    OPW_VISKTL_RESET_SATI_RADA:"Hogedrukpomp servies",
    OP_FILTER_DANI_RADA:"Waterfilter fout",
    OP_BOJLER_DANI_RADA:"Ketel fout",
    OPW_ALARM_VISOKOTL_PUMPA:"Hogedrukpomp alarm",
    OPW_ALARM_FILTER_SERVIS:"Filter servies alarm",
    OPW_ALARM_BOJLER_SERVIS:"Ketel servies alarm",
    HAS_MEMBERS:"De geselecteerde groep heeft leden en kan niet worden verwijderd. Leden moeten eerst worden verwijderd.",
    PERIODIC_SUMMARY_FOR:"PERIODIEK SAMENVATTEND RAPPORT VOOR",
    PERIODIC_SUMMARY_REPORTS:"Periodieke samenvattend rapport",
    DATE_RANGE:"Datumbereik",
    FINANCIAL_REPORT:"Finantieel rapport",
    GROSS_INCOME:"Bruto inkomen",
    GROSS_INCOME_SUM:"Bruto inkomen som",
    COMMISSION_FEE:"Provisie vergoeding",
    NET_INCOME:"Net inkomen (voor facturering)",
    COMMISSION_FEE_DETAILS:"Provisie vergoeding bevat bank / PayPal provisie of SMS providers dienst vergoeding ",
    LOYALTY_CREDITS_REPORT:"Lokale munten rapport",
    LOYALTY_GIVEN:"Lokale munten uitgegeven",
    LOYALTY_USED:"Lokale munten gebruikt",
    LOYALTY_SOLD:"Lokale munten ingeladen ",
    LOYALTY_TOTAL:"Totaal",
    LOYALTY_CURRENT_MONTH:"Deze maand",
    SOMETHING_WENT_WRONG:"Oooooops",
    MISSING_PAGE:"Sorry. We konden die pagina niet vinden",
    TRY_AGAIN:"Probeer opnieuw",
    DEFAULT_ERROR_NAME:"Onbekende fout opgetreden",
    DEFAULT_ERROR_DESCRIPTION:"Probeer het opnieuw alstublieft ",
    MY_ACCOUNT_DETAILS:"Mijn account gegevens",
    SAVE_CHANGES:"Veranderingen opslaan",
    USERNAME:"Gebruikersnaam",
    FIRST_NAME:"Voornaam",
    LAST_NAME:"Achternaam",
    USER_ROLE:"Gebruikersrol",
    OLD_PASSWORD:"Oud wachtwoord",
    NEW_PASSWORD:"Nieuw wachtwoord",
    OLD_PASSWORD_REQUIRED:"Oud wachtwoord vereist",
    NEW_PASSWORD_REQUIRED:"Nieuw wachtwoord vereist",
    NEW_PASSWORD_REPEAT:"Herhaling van nieuw wachtwoord is vereist",
    NEW_PASSWORD_NOT_MATCH:"Oud en nieuw wachtwoord komen niet overeen",
    PASSWORD_DIFFERENT_VALIDATION:"Het nieuwe wachtwoord moet anders zijn dan het oude",
    PASSWORD_MIN_CHAR:"Uw wachtwoord moet minimaal acht symbolen lang zijn",
    PASSWORD_MAX_CHAR:"Uw wachtwoord mag maximaal 32 symbolen lang zijn",
    PASSWORD_PATTERN_VALIDATION:"Wachtwoord moet minimaal een getal bevatten",
    ACCOUNT_MANAGEMENT:"Accountbeheer",
    NOT_ACTIVE:"Niet aktief",
    ASSIGN_ROLE:"Rol toewijzen",
    UPDATE:"Bijwerken",
    ADD_NEW_ACCOUNT:"Nieuw account toevoegen",
    EMAIL_REQUIRED:"E-mail adres is vereist",
    EMAIL_NOT_VALID:"E-mail adres ongeldig",
    ADD_NEW_USER_TEXT:"E-mail met activatielink wordt naar het opgegeven e-mailadres gestuurd.",
    UPDATE_USER_NOTIFICATION:"U heeft uw informatie met succes bijgewerkt",
    CHANGED_PASSWORD_NOTIFICATION:"U heeft uw informatie met succes verandert",
    UPDATE_USER_GROUP_NOTIFICATION:"U heeft de naam van de gebruikersgroep met succes bijgewerkt",
    CREATE_USER_GROUP_NOTIFICATION:"U heeft met succes een groep gemaakt",
    DETELE_USER_GROUP_NOTIFICATION:"U heeft met succes een groep verwijdert",
    EMPTY_GROUP_LIST_MSG:"Er zijn geen gemaakte groepen. Begin met maken van een groep",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"U heeft de gebruiker uit de groep verwijderd",
    ADD_USER_TO_GROUP_NOTIFICATION:"U heeft de gebruiker met succes aan de groep toegevoegd",
    ADD_USER_NOTIFICATION:"U heeft met succes de gebruiker toegevoegd ",
    DELETE_USER_NOTIFICATION:"U heeft met succes de gebruiker verwijdert",
    RESEND_USER_VERIFICATION_EMAIL:"U hebt succesvol de verificatie-e-mail opnieuw verzonden",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Om een gebruikersgroep aan te maken",
    DELETE_USER:"Gebruiker verwijderen",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Weet u zeker dat u de gebruiker uit de gebruikersgroep wilt verwijderen?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Beste R2W gebruiker",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Loyaliteitsregel per aantal bezoeken",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Loyaliteitsregel per aantal uitgegeven munten",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Loyaliteitsregel per dag van de week",
    REMOVE_CAMPAIGN_RULE_TITLE:"Campagneregel verwijdering",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Weet u zeker dat u de campagneregel wilt verwijderen?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Je hebt met succes een nieuwe campagne gemaakt",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"U heeft de campagne geactiveerd",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Er zijn geen gemaakte campagnes. Begin met het maken van een",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"U heeft  met succes een bericht gestuurd",
    COMPANY_ACCOUNTS:"Bedrijfsaccount",
    BUSSINESS_INVOICES_LIST:"Mijn B2B facturen ",
    LOCALE_TOKEN:"Lokale munten",
    R2W:"Globaal munten",
    START_MONTH:"Begin maand",
    END_MONTH:"End maand",
    TOKEN_TYPE:"Munt type",
    TOKEN_NUMBER:"Munt nummer",
    NOTHING_TO_DISPLAY:"* Niets om te laten zien",
    CREATE_INVOICE:"Factuur maken",
    INVOICE:"Factuur",
    INVOICES:"Factuuren",
    EDIT_INVOICE:"Factuur bewerken ",
    UPDATE_INVOICE_NOTIFICATION:"U heeft de factuur succesvol bijgewerkt naar de status 'In behandeling'",
    CURRENT_CHARGES:"Kosten voor de huidige periode",
    PAYMENTS_ON_HOLD:"Facturen in behandeling",
    FOR_INVOICING:"voor factureren",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"U staat op het punt de factuur te annuleren",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Weet u zeker dat u deze factuur wilt annuleren?",
    INVOICING_NOTIFICATION_HEADER:"U staat op het punt om te factureren",
    INVOICING_NOTIFICATION_TEXT:"Weet u zeker dat u deze factuur wilt versturen?",
    SENT_INVOICE_NOTIFICATION:"U heeft met succes een factuur verzonden",
    CANCELED_INVOICE_NOTIFICATION:"U heeft met succes een factuur granuleert ",
    INVOICE_DESCRIPTION_TEXT:"Factuur voor",
    INVOICE_STATE:"Factuur status",
    INVOICE_NUMBER:"Factuur nummer",
    INVOICE_TOTAL:"Totaal",
    SELECT_YEAR:"Selecteer jaar",
    DOWNLOAD:"PDF downloaden",
    INVOICE_NUMBER_HEADER:"U staat op het punt een factuur te verzenden met nummer",
    INVOICE_PAYMENT_CONFIRMATION:"Je gaat bevestigen de betaling voor",
    INSERT_INVOICE_NUMBER:"Factuur nummer invoegen",
    INVOICED_WARNING:"E-mail was niet verstuurd. Wacht alsjeblieft ...",
    SEND_INVOICE:"Verzenden",
    INVOICE_ALL:"Alle ",
    INVOICE_FROM_R2W:"Van R2W",
    INVOICE_TO_R2W:"Naar R2W",
    PAYMENT_REQUEST:"Betaal verzoek",
    PAYMENT_REQUEST_STATE:"Status betalingsverzoek",
    PAYMENT_REQUEST_NUMBER:"Nummer betalingsverzoek",
    FOR_PAYMENT_REQUEST:"Voor betalingsverzoeken",
    PAYMENT_REQUEST_ON_HOLD:"Betalingsverzoeken in behandeling",
    DOWNLOAD_INVOICE:"Factuur downloaden",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Klik voor downloadopties",
    B2B_SPEC:"B2B Specificatie",
    B2C_SPEC:"B2C Specificatie",
    DOWNLOAD_PAYMENT_REQUEST:"Betalingsverzoek downloaden",
    LOYALTY_PREVIEW:"Loyaliteitsvoorbeeld",
    ACTIVATED:"Geactiveerd",
    RUNNING:"Aan het uitvoeren",
    NOT_ACTIVATED:"Niet geactiveerd ",
    FINISHED:"Afgewerkt",
    DEPRECATED:"Verouderd",
    UPCOMING:"Aanstaande",
    NONE:"Geen",
    STARTED:"Begonnen",
    ENDS:"Loopt af",
    DEDICATED:"Toegewijd aan",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"U staat op het punt te activeren",
    CAMPAIGN:"campagne",
    SEND_MESSAGE_NOTIFICATION:"U staat op het punt een bericht te verzenden naar geselecteerde gebruikersgroepen",
    DIVISIBLE_TO_NUMBER:"Het nummer moet deelbaar zijn met",
    BRIDGE_PLC:"Brug - PLC",
    DEVICE_TYPE:"Soort apparaat",
    LISTENER:"Kleine machines",
    BRIDGE:"Wasboksen",
    WASH_BOXES:"Wasboksen",
    VACUUMS:"Stofzuigers",
    SAVE_NEWS:"Nieuws opslaan",
    CREATE_NEW_NEWS:"Maak nieuwe nieuws",
    HISTORY_OF_ALL_NEWS:"Geschiedenis van alle nieuws",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Typ de naam van de faciliteit",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Voeg een andere faciliteit toe",
    NEWS_TEXT:"Nieuws tekst",
    NEWS_TITLE:"Nieuws titel",
    DELETE_NEWS_CONFIRMATION:"U staat op het punt om nieuws te verwijderen",
    NEWS_DELETE_NOTIFICATION:"U heeft met succes nieuws verwijderd",
    NEWS_SAVE_NOTIFICATION:"U heeft met succes nieuws opgeslagen",
    NEWS_CREATION_DATE:"Aanmaakdatum",
    NO_TITLE:"Geen titel",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Nieuws tekst moet minder dan 255 symbolen bevatten",
    NEWS_TEXT_REQUIRED_VALIDATION:"Nieuws tekst vereist ",
    NEWS_TITLE_REQUIRED_VALIDATION:"Nieuws tekst vereist ",
    DEACTIVATE:"Deactiveren",
    ASIDE_MENU_LOCAL_TOKENS:"Lokale munten",
    CREATE_NEW_LOCAL_TOKENS:"Geef nieuwe lokale munten uit",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Voer het e-mailadres van de klant in en het aantal lokale munten dat u aan de klant wilt geven",
    CREATE_TOKENS:"Geef munten uit",
    MINIMUM_ONE_TOKEN:"Waarde moet groter dan 0 zijn",
    CUSTOMER_EMAIL:"Klanten e-mail",
    AMOUNT_OF_TOKENS:"Aantal munten",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Succesvolle uitgifte van lokale tokens aan",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Er is een fout opgetreden bij het uitgeven van lokale munten. Controleer het e-mailadres van de klant en probeer het opnieuw.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Overzicht van uitgegeven munten",
    ISSUED_AT:"Uitgegeven aan",
    ISSUED_BY:"Uitgegeven door",
    CODE:"Code inwisselen",
    REDEEMED_BY:"Ingewisseld door",
    REDEEMED_AT:"Ingewisseld bij",
    ASIDE_MENU_VOUCHERS:"Waardebonnen",
    PRINT:"Afdrukken",
    VOUCHERS_OVERVIEW:"Waardebonnen overzicht",
    CREATE_NEW_VOUCHERS:"Nieuwe waardebonnen maken",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Maak een nieuwe inwisselbare waardebonnen partij door het aantal munten per voucher in te voeren",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Aantal munten per waardebon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"U kunt per voucher tussen de 1 en 100 munten toewijzen",
    NUMBER_OF_NEW_VOUCHERS:"Aantal te creëren waardebonnen",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"U kunt in één batch tussen 1 en {{size}} waardebonnen maken",
    NEW_VOUCHERS_PREFIX:"Nieuw code-voorvoegsel voor serie vouchers",
    VALIDATION_VOUCHER_PREFIX:"Het codevoorvoegsel moet exact 4 tekens bevatten (hoofdletters en / of cijfers)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Er is een probleem opgetreden bij het maken van nieuwe waardebonnen. Probeer het opnieuw of neem contact op met onze ondersteuning.",
    CREATE_VOUCHERS:"Maak waardebonnen",
    CREATING_VOUCHERS_SUCCESS:"Nieuwe waardebonnen met succes gemaakt",
    PRINT_NEW_VOUCHERS:"Waardebonnen afdrukken",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Voer een codevoorvoegsel voor de waardebonnenserie in om de hele serie af te drukken. alternatief",
    PRINT_VOUCHERS_PREFIX:"Waardebonnen (serie) codevoorvoegsel",
    NO_VOUCHERS_FOR_PRINT:"Er zijn geen waardebonnen gevonden die overeenkomen met het opgegeven codevoorvoegsel voor afdrukken",
    PRINT_VOUCHERS:"Waardebon(nen) afdrukken",
    VALIDATION_VOUCHER_CODE_FILTER:"De zoekterm voor waardebonnen moet bestaan uit hoofdletters en cijfers",
    FILTER_VOUCHERS_BY_CODE:"Zoek waardebonnen bij hun inwissel code",
    FILTER_VOUCHERS:"Waardebonnen zoeken",
    WASH_BOX:"Wasboks",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Totaal gebruikte digitale tokens",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Totaal verkochte munten per datum",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Totaal uitgegeven lokale munten op datum",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Totaal gegeven lokale munten op datum",
    LOCAL_TOKEN:"Lokaal munten",
    GIVEN_TOKEN:"Gegeven lokale munten",
    SOLD_TOKEN:"Verkochte lokale munten",
    SMALL_MACHINES:"Kleine machines",
    R2W_Listener:"Luisteraar ",
    HHANLE_DEVICE:"HHanle wasboks",
    CODE_PREFIX_EXIST:"Het codevoorvoegsel bestaat al",
    CODE_PREFIX_EXIST_TEXT:"U kunt geen nieuwe voucher maken met dit codevoorvoegsel. Stel een andere in altublieft..",
    MIN_FOUR_VALIDATION:"Exact 4 symbolen",
    ALL_INFORMATION_1:"Alle informatie over",
    ALL_INFORMATION_2:"wordt verloren",
    ASIDE_MENU_TRANSACTIONS:"Transacties",
    EXPENSES:"Kosten",
    TOPUPS:"TopUps",
    EXPENSES_LIST:"Kostenlijst",
    USER_EMAIL:"Gebruikers e-mail",
    COMPANY_NAME:"Bedrijfsnaam",
    TOPUPS_LIST:"Top-ups lijst",
    CONSUMER:"Consument",
    SYSTEM_ADMIN:"Systeem beheerder ",
    MERCHANT_ADMIN:"Merchant-beheerder",
    COMPANY_ADMIN:"Bedrijfsbeheerder",
    FACILITY_ADMIN:"Faciliteitsbeheerder",
    SUBSCRIBER:"Abonee",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serienummer",
    SETUP_UNIT_MATERIAL_NO:"Materiaalnummer",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi versie",
    TOTAL_TURNOVER:"Washfaciliteit omzet",
    AVAILABILITY_ALL:"Beschikbaarheid ",
    AVAILIBILITY:"Beschikbaarheid wasboksen:",
    AVAILABILITY_VACUUMS:"Stofzuiger beschikbaarheid:",
    WASH_BOX_INFO:"Wasboksen informatie",
    VACUUM_CLEANER_INFO:"Stofzuiger informatie",
    BREAD_CRUMBS_SERVICE:"Diensten",
    HOLIDAYS:"Vakantie",
    HOLIDAY:"Vakantie",
    LIGHTS_ON:"Licht/aan",
    LIGHTS_OFF:"Licht/uit",
    WASH_BOXES_ON:"Wasboks/aan",
    WASH_BOXES_OFF:"Wasboks/uit",
    VACUUMS_ON:"Stofzuiger/aan",
    VACUUMS_OFF:"Stofzuiger/uit",
    TURNOVER:"Omzet",
    TURNOVER_MANUAL_WASH_UNIT:"Omzet handleiding",
    STATUS_BAY_RUN_TIME:"Totale werktijd wasboksen",
    STATUS_BAY_PROGRAM_NAME:"Programma naam ",
    STATUS_BAY_CREDIT:"Wasboks credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Totale werktijd stofzuiger",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facilitaire diensten, wasboxprogramma en actuele foutgegevens",
    UNAVAILABLE:"Eenheid is niet beschikbaar",
    SHOW_HIDE_TABLE:"Tabel werktijden weergeven/verbergen",
    PROGRAM_NAME:"Programma naam",
    PROGRAM_OPTION:"Programma optie",
    DEVICE:"Apparaat",
    QUANTITY:"Hoeveelheid",
    PROGRAM_COUNTER:"Programma teller",
    NO_NAME:"Referentie heeft geen naam",
    COUNTER_SERVICE_DATA:"Dienst gegevens",
    NEED_SERVICE:"Onderhoud nodig",
    PROGRAM_DATA:"Programmagegevens van wasboks",
    CURRENT_FAULT_DATA:"Huidige fout gegevens",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconden",
    REFERENCE_NAME:"Deeltijd ",
    WASHBOX_NAME:"Naam wasboks",
    FAULT_NAME:"Fout naam",
    FAULT_NUMBER:"Fout nummer",
    CURRENT_FAULT_COUNT:"Actieve fouten",
    DEVICE_NOT_INSTALLED:"Apparaat niet geïnstalleerd",
    STATUS_READY:"status gereed",
    STATUS_ERROR:"Fout status",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Softwarefout",
    SOFTWARE_RESET:"Softwarefout",
    EXTERNAL_PIN_RESET:"Softwarefout",
    RESTART_OR_BROWNOUT_OCCURRED:"Softwarefout",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardwarefout",
    COULD_NOT_SIMULATE_COIN:"Hardwarefout",
    ERROR_SETTING_INHIBIT_MODE:"Hardwarefout",
    OFFLINE_DEVICE:"Offline autowasstraat",
    TARIFFS:"Tarieven",
    DAY:"Dag",
    NIGHT:"Nacht",
    VOUCHER_CODE:"Waardeboncode",
    DISMISS_ALARM:"Alarm resetten?",
    ALARM_ACTIVE:"Actieve alarmen",
    NO_ALARM_ACTIVE:"Er zijn geen actieve alarmen",
    ALARM_HISTORY:"Meldingsgeschiedenis",
    MANAGING_TOKENS:"Tokens beheren",
    EXPIRATION_DATE:"Uiterste houdbaarheidsdatum",
    EXTEND_TOKEN_DATE:"Verleng de vervaldatum van het token voor:",
    DELETE_TOKENS_FOR:"Tokens verwijderen voor",
    PUMP_TYPE:"Pomptype",
    TURN_OFF_DEVICE:"Apparaatstatus",
    OPERATION_DATA:"Bedrijfsgegevens",
    PUMP_DATA:"Pompen gegevens",
    PUMP_NAME:"Pompen naam",
    POINT_NAME:"Puntnaam",
    CHANGER_INCOME:"Totaal omzet door wisselaar op datum",
    SELECTED_OPEN:"Open op geselecteerde werkuren",
    ALWAYS_OPEN:"Altijd open (24/7)",
    CLOSED:"Gesloten",
    CLOSED_24:"24 uur gesloten",
    OPENED_24:"24 uur geopend",
    MON:"Maandag",
    TUE:"Dinsdag",
    WED:"Woensdag",
    THU:"Donderdag",
    FRI:"Vrijdag",
    SAT:"Zaterdag",
    SUN:"Zondag",
    PRICING:"Prijzen",
    PRICE:"Prijs",
    VALIDITY:"Geldigheid",
    TOKEN_PACKAGES:"Tokenpakketten",
    SINGLE_WASH:"Enkele wasbeurt",
    FACILITY_WORKING_HOURS:"Werkuren instellen voor geselecteerde faciliteit",
    WORKING_HOURS_ALWAYS_OPEN:"Altijd open",
    WORKING_HOURS_ALWAYS_CLOSE:"Gesloten door operator",
    WORKING_HOURS_CUSTOM:"Werkuren instellen",
    KARCHER_ERROR_CODE:"Meldingsfoutcode",
    KARCHER_ERROR_MESSAGE_1:"Elektronische stopcontacten overbelast",
    KARCHER_ERROR_MESSAGE_2:"De olieafscheider moet worden geleegd",
    KARCHER_ERROR_MESSAGE_4:"Dimsensor defect",
    KARCHER_ERROR_MESSAGE_5:"Motorbeveiligingsschakelaar op hogedrukpompen is geactiveerd",
    KARCHER_ERROR_MESSAGE_6:"Verbinding met RDS defect",
    KARCHER_ERROR_MESSAGE_7:"De drukschakelaar voor lucht op de compressor meldt geen",
    KARCHER_ERROR_MESSAGE_8:"Oorzaak: geen verbinding met de elektronica 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Geen verbinding met pompelektronica op wasstation 1",
    KARCHER_ERROR_MESSAGE_11:"Elektronische stopcontacten bij wasstation 1 overbelast",
    KARCHER_ERROR_MESSAGE_12:"Stroomopname van hogedrukpomp bij wasstation 1 te hoog",
    KARCHER_ERROR_MESSAGE_13:"Stroomopname van hogedrukpomp bij wasstation 1 te laag",
    KARCHER_ERROR_MESSAGE_14:"Contact van hogedrukpomp bij wasstation 1 zit vast",
    KARCHER_ERROR_MESSAGE_15:"Semiloadklep bij wasstation 1 defect",
    KARCHER_ERROR_MESSAGE_16:"Coilbeschermingscontact van hogedrukpompwasstation 1",
    KARCHER_ERROR_MESSAGE_17:"Oliepeil hogedrukpomp bij wasstation 1 te laag",
    KARCHER_ERROR_MESSAGE_18:"Elektronica bij wasstation 1 defect",
    KARCHER_ERROR_MESSAGE_19:"Zekering motor hogedrukpomp wasstation 1 is uitgevallen",
    KARCHER_ERROR_MESSAGE_20:"Geen verbinding met afstandsbedieningselektronica bij wasstation 1",
    KARCHER_ERROR_MESSAGE_21:"Storing muntautomaat wasstation 1",
    KARCHER_ERROR_MESSAGE_22:"Storing muntautomaat wasstation 1",
    KARCHER_ERROR_MESSAGE_30:"Geen verbinding met pompelektronica op wasstation 2",
    KARCHER_ERROR_MESSAGE_31:"Elektronische stopcontacten bij wasstation 2 overbelast",
    KARCHER_ERROR_MESSAGE_32:"Stroomopname van hogedrukpomp bij wasstation 2 te hoog",
    KARCHER_ERROR_MESSAGE_33:"Stroomopname van hogedrukpomp bij wasstation 2 te laag",
    KARCHER_ERROR_MESSAGE_34:"Contact van hogedrukpomp bij wasstation 2 zit vast",
    KARCHER_ERROR_MESSAGE_35:"Semiloadklep bij wasstation 2 defect",
    KARCHER_ERROR_MESSAGE_36:"Coilbeschermingscontact van hogedrukpompwasstation 2",
    KARCHER_ERROR_MESSAGE_37:"Oliepeil hogedrukpomp bij wasstation 2 te laag",
    KARCHER_ERROR_MESSAGE_38:"Elektronica bij wasstation 2 defect",
    KARCHER_ERROR_MESSAGE_39:"Zekering motor hogedrukpomp wasstation 2 is uitgevallen",
    KARCHER_ERROR_MESSAGE_40:"Geen verbinding met afstandsbedieningselektronica bij wasstation 2",
    KARCHER_ERROR_MESSAGE_41:"Storing muntautomaat wasstation 2",
    KARCHER_ERROR_MESSAGE_42:"Storing muntautomaat wasstation 2",
    KARCHER_ERROR_MESSAGE_50:"Geen verbinding met pompelektronica op wasstation 3",
    KARCHER_ERROR_MESSAGE_51:"Elektronische stopcontacten bij wasstation 3 overbelast",
    KARCHER_ERROR_MESSAGE_52:"Stroomopname van hogedrukpomp bij wasstation 3 te hoog",
    KARCHER_ERROR_MESSAGE_53:"Stroomopname van hogedrukpomp bij wasstation 3 te laag",
    KARCHER_ERROR_MESSAGE_54:"Contact van hogedrukpomp bij wasstation 3 zit vast",
    KARCHER_ERROR_MESSAGE_55:"Semiloadklep bij wasstation 3 defect",
    KARCHER_ERROR_MESSAGE_56:"Coilbeschermingscontact van hogedrukpompwasstation 3",
    KARCHER_ERROR_MESSAGE_57:"Oliepeil hogedrukpomp bij wasstation 3 te laag",
    KARCHER_ERROR_MESSAGE_58:"Elektronica bij wasstation 3 defect",
    KARCHER_ERROR_MESSAGE_59:"Zekering motor hogedrukpomp wasstation 3 is uitgevallen",
    KARCHER_ERROR_MESSAGE_60:"Geen verbinding met afstandsbedieningselektronica bij wasstation 3",
    KARCHER_ERROR_MESSAGE_61:"Storing muntautomaat wasstation 3",
    KARCHER_ERROR_MESSAGE_62:"Storing muntautomaat wasstation 3",
    KARCHER_ERROR_MESSAGE_70:"Geen verbinding met pompelektronica op wasstation 4",
    KARCHER_ERROR_MESSAGE_71:"Elektronische stopcontacten bij wasstation 4 overbelast",
    KARCHER_ERROR_MESSAGE_72:"Stroomopname van hogedrukpomp bij wasstation 4 te hoog",
    KARCHER_ERROR_MESSAGE_73:"Stroomopname van hogedrukpomp bij wasstation 4 te laag",
    KARCHER_ERROR_MESSAGE_74:"Contact van hogedrukpomp bij wasstation 4 zit vast",
    KARCHER_ERROR_MESSAGE_75:"Semiloadklep bij wasstation 4 defect",
    KARCHER_ERROR_MESSAGE_76:"Coilbeschermingscontact van hogedrukpompwasstation 4",
    KARCHER_ERROR_MESSAGE_77:"Oliepeil hogedrukpomp bij wasstation 4 te laag",
    KARCHER_ERROR_MESSAGE_78:"Elektronica bij wasstation 4 defect",
    KARCHER_ERROR_MESSAGE_79:"Zekering motor hogedrukpomp wasstation 4 is uitgevallen",
    KARCHER_ERROR_MESSAGE_80:"Geen verbinding met afstandsbedieningselektronica bij wasstation 4",
    KARCHER_ERROR_MESSAGE_81:"Storing muntautomaat wasstation 4",
    KARCHER_ERROR_MESSAGE_82:"Storing muntautomaat wasstation 4",
    KARCHER_ERROR_MESSAGE_90:"Geen verbinding met pompelektronica op wasstation 5",
    KARCHER_ERROR_MESSAGE_91:"Elektronische stopcontacten bij wasstation 5 overbelast",
    KARCHER_ERROR_MESSAGE_92:"Stroomopname van hogedrukpomp bij wasstation 5 te hoog",
    KARCHER_ERROR_MESSAGE_93:"Stroomopname van hogedrukpomp bij wasstation 5 te laag",
    KARCHER_ERROR_MESSAGE_94:"Contact van hogedrukpomp bij wasstation 5 zit vast",
    KARCHER_ERROR_MESSAGE_95:"Semiloadklep bij wasstation 5 defect",
    KARCHER_ERROR_MESSAGE_96:"Coilbeschermingscontact van hogedrukpompwasstation 5",
    KARCHER_ERROR_MESSAGE_97:"Oliepeil hogedrukpomp bij wasstation 5 te laag",
    KARCHER_ERROR_MESSAGE_98:"Elektronica bij wasstation 5 defect",
    KARCHER_ERROR_MESSAGE_99:"Zekering motor hogedrukpomp wasstation 5 is uitgevallen",
    KARCHER_ERROR_MESSAGE_100:"Geen verbinding met afstandsbedieningselektronica bij wasstation 5",
    KARCHER_ERROR_MESSAGE_101:"Storing muntautomaat wasstation 5",
    KARCHER_ERROR_MESSAGE_102:"Storing muntautomaat wasstation 5",
    KARCHER_ERROR_MESSAGE_110:"Geen verbinding met pompelektronica op wasstation 6",
    KARCHER_ERROR_MESSAGE_111:"Elektronische stopcontacten bij wasstation 6 overbelast",
    KARCHER_ERROR_MESSAGE_112:"Stroomopname van hogedrukpomp bij wasstation 6 te hoog",
    KARCHER_ERROR_MESSAGE_113:"Stroomopname van hogedrukpomp bij wasstation 6 te laag",
    KARCHER_ERROR_MESSAGE_114:"Contact van hogedrukpomp bij wasstation 6 zit vast",
    KARCHER_ERROR_MESSAGE_115:"Semiloadklep bij wasstation 6 defect",
    KARCHER_ERROR_MESSAGE_116:"Coilbeschermingscontact van hogedrukpompwasstation 6",
    KARCHER_ERROR_MESSAGE_117:"Oliepeil hogedrukpomp bij wasstation 6 te laag",
    KARCHER_ERROR_MESSAGE_118:"Elektronica bij wasstation 6 defect",
    KARCHER_ERROR_MESSAGE_119:"Zekering motor hogedrukpomp wasstation 6 is uitgevallen",
    KARCHER_ERROR_MESSAGE_120:"Geen verbinding met afstandsbedieningselektronica bij wasstation 6",
    KARCHER_ERROR_MESSAGE_121:"Storing muntautomaat wasstation 6",
    KARCHER_ERROR_MESSAGE_122:"Storing muntautomaat wasstation 6",
    KARCHER_ERROR_MESSAGE_130:"Geen verbinding met pompelektronica op wasstation 7",
    KARCHER_ERROR_MESSAGE_131:"Elektronische stopcontacten bij wasstation 7 overbelast",
    KARCHER_ERROR_MESSAGE_132:"Stroomopname van hogedrukpomp bij wasstation 7 te hoog",
    KARCHER_ERROR_MESSAGE_133:"Stroomopname van hogedrukpomp bij wasstation 7 te laag",
    KARCHER_ERROR_MESSAGE_134:"Contact van hogedrukpomp bij wasstation 7 zit vast",
    KARCHER_ERROR_MESSAGE_135:"Semiloadklep bij wasstation 7 defect",
    KARCHER_ERROR_MESSAGE_136:"Coilbeschermingscontact van hogedrukpompwasstation 7",
    KARCHER_ERROR_MESSAGE_137:"Oliepeil hogedrukpomp bij wasstation 7 te laag",
    KARCHER_ERROR_MESSAGE_138:"Elektronica bij wasstation 7 defect",
    KARCHER_ERROR_MESSAGE_139:"Zekering motor hogedrukpomp wasstation 7 is uitgevallen",
    KARCHER_ERROR_MESSAGE_140:"Geen verbinding met afstandsbedieningselektronica bij wasstation 7",
    KARCHER_ERROR_MESSAGE_141:"Storing muntautomaat wasstation 7",
    KARCHER_ERROR_MESSAGE_142:"Storing muntautomaat wasstation 7",
    KARCHER_ERROR_MESSAGE_150:"Geen verbinding met pompelektronica op wasstation 8",
    KARCHER_ERROR_MESSAGE_151:"Elektronische stopcontacten bij wasstation 8 overbelast",
    KARCHER_ERROR_MESSAGE_152:"Stroomopname van hogedrukpomp bij wasstation 8 te hoog",
    KARCHER_ERROR_MESSAGE_153:"Stroomopname van hogedrukpomp bij wasstation 8 te laag",
    KARCHER_ERROR_MESSAGE_154:"Contact van hogedrukpomp bij wasstation 8 zit vast",
    KARCHER_ERROR_MESSAGE_155:"Semiloadklep bij wasstation 8 defect",
    KARCHER_ERROR_MESSAGE_156:"Coilbeschermingscontact van hogedrukpompwasstation 8",
    KARCHER_ERROR_MESSAGE_157:"Oliepeil hogedrukpomp bij wasstation 8 te laag",
    KARCHER_ERROR_MESSAGE_158:"Elektronica bij wasstation 8 defect",
    KARCHER_ERROR_MESSAGE_159:"Zekering motor hogedrukpomp wasstation 8 is uitgevallen",
    KARCHER_ERROR_MESSAGE_160:"Geen verbinding met afstandsbedieningselektronica bij wasstation 8",
    KARCHER_ERROR_MESSAGE_161:"Storing muntautomaat wasstation 8",
    KARCHER_ERROR_MESSAGE_162:"Storing muntautomaat wasstation 8",
    KARCHER_ERROR_MESSAGE_170:"Geen verbinding met elektronica A2 overbelast ",
    KARCHER_ERROR_MESSAGE_171:"Uitgang van de elektronica A2 overbelast",
    KARCHER_ERROR_MESSAGE_172:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_173:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_174:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_175:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_176:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_177:"Stroomopname van onderwagenreinigingspomp was te hoog",
    KARCHER_ERROR_MESSAGE_178:"Geen druk na het inschakelen van de bodemwas",
    KARCHER_ERROR_MESSAGE_190:"Geen verbinding met elektronica A3",
    KARCHER_ERROR_MESSAGE_191:"Uitgang van de elektronica A3 overbelast",
    KARCHER_ERROR_MESSAGE_200:"Geen verbinding tussen besturing en elektronica van de WSO",
    KARCHER_ERROR_MESSAGE_201:"Uitgangen van de besturing naar de WSO overbelast",
    KARCHER_ERROR_MESSAGE_202:"De hardheidssensor toont na regeneratie hard water",
    KARCHER_ERROR_MESSAGE_204:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_210:"Niveausensor BUFFERTANK LEEG geactiveerd",
    KARCHER_ERROR_MESSAGE_211:"Niveausensor BUFFER CONTAINER LEEG en BUFFER CONTAINER FULL-schakelaar tegelijkertijd",
    KARCHER_ERROR_MESSAGE_212:"Niveausensor RO PUMP ON en BUFFER CONTAINER FULL-schakelaar tegelijkertijd",
    KARCHER_ERROR_MESSAGE_213:"Geen waterdruk ",
    KARCHER_ERROR_MESSAGE_214:"Locatie geleverde waterbereiding meldt een storing",
    KARCHER_ERROR_MESSAGE_220:"Watertekort",
    KARCHER_ERROR_MESSAGE_221:"Uitlaattemperatuur is te hoog",
    KARCHER_ERROR_MESSAGE_222:"Stroomopname circulatiepomp voor warm water te hoog",
    KARCHER_ERROR_MESSAGE_223:"Storing brander",
    KARCHER_ERROR_MESSAGE_224:"Veiligheidsthermostaat van de brander is geactiveerd",
    KARCHER_ERROR_MESSAGE_225:"Brandervertraging actief",
    KARCHER_ERROR_MESSAGE_226:"Stroomindicator ging niet open binnen 5 seconden nadat de circulatiepomp voor warm water was uitgeschakeld",
    KARCHER_ERROR_MESSAGE_227:"Stroomindicator ging niet open binnen 3 seconden nadat de circulatiepomp voor warm water was uitgeschakeld",
    KARCHER_ERROR_MESSAGE_228:"De uitlaat voor warm water koelt te langzaam af nadat de brander is uitgeschakeld",
    KARCHER_ERROR_MESSAGE_229:"Storing temperatuursensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Storing in temperatuursensor branderuitlaat",
    KARCHER_ERROR_MESSAGE_231:"Storing in temperatuursensor warm water ",
    KARCHER_ERROR_MESSAGE_232:"Storing in temperatuursensor branderuitlaat",
    KARCHER_ERROR_MESSAGE_233:"Watertemperatuur met externe toevoer met warm water heter dan 60 ° C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionellaprogrammafout",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warmwatertemperatuur niet bereikt",
    KARCHER_ERROR_MESSAGE_240:"Storing buitentemperatuursensor",
    KARCHER_ERROR_MESSAGE_241:"Storing buitentemperatuursensor",
    KARCHER_ERROR_MESSAGE_242:"Stroomopname circulatiepomp voor vorstbeveiliging te hoog ",
    KARCHER_ERROR_MESSAGE_243:"Stroomopname circulatiepomp voor wasstationverwarming te hoog",
    KARCHER_ERROR_MESSAGE_244:"Warmwatertemperatuur te laag, wasstationverwarming was uitgeschakeld",
    KARCHER_ERROR_MESSAGE_245:"Stroomverbruik van schuimslangverwarmer voor het schuim te hoog",
    KARCHER_ERROR_MESSAGE_247:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_248:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_250:"Stroomopname pomp voor speciaal wasprogramma te hoog",
    KARCHER_ERROR_MESSAGE_255:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_260:"Geen verbinding met elektronica A5",
    KARCHER_ERROR_MESSAGE_261:"Uitgangen van de elektronica A5 overbelast",
    KARCHER_ERROR_MESSAGE_280:"Geen verbinding met elektronica A6",
    KARCHER_ERROR_MESSAGE_281:"Uitgangen van de elektronica A6 overbelast",
    KARCHER_ERROR_MESSAGE_282:"Stroomverbruik pomp voor velgenreiniger te hoog",
    KARCHER_ERROR_MESSAGE_283:"Stroomverbruik pomp voor velgenreiniger te laag",
    KARCHER_ERROR_MESSAGE_284:"Schakelaar van pomp voor velgenreiniger zit vast",
    KARCHER_ERROR_MESSAGE_300:"Geen verbinding met elektronica A7",
    KARCHER_ERROR_MESSAGE_301:"Uitgangen van de elektronica A7 overbelast",
    KARCHER_ERROR_MESSAGE_320:"Geen verbinding met elektronica A8",
    KARCHER_ERROR_MESSAGE_321:"Uitgangen van de elektronica A8 overbelast",
    KARCHER_ERROR_MESSAGE_322:"Stroomverbruik van pomp voor micro-emulsie te hoog",
    KARCHER_ERROR_MESSAGE_323:"Stroomverbruik pomp voor micro-emulsie te laag",
    KARCHER_ERROR_MESSAGE_324:"Schakelaar van pomp voor micro-emulsie zit vast",
    KARCHER_ERROR_MESSAGE_340:"Geen verbinding met elektronica A9",
    KARCHER_ERROR_MESSAGE_341:"Uitgangen van de elektronica A9 overbelast",
    KARCHER_ERROR_MESSAGE_342:"Stroomverbruik pomp voor intensieve reiniging te hoog",
    KARCHER_ERROR_MESSAGE_343:"Stroomverbruik pomp voor intensieve reiniging te laag",
    KARCHER_ERROR_MESSAGE_344:"Schakelaar van pomp voor intensieve reiniging is vastgelopen",
    KARCHER_ERROR_MESSAGE_400:"Warm water zonder druk",
    KARCHER_ERROR_MESSAGE_401:"Zoet water geen druk",
    KARCHER_ERROR_MESSAGE_402:"Doordring geen druk",
    KARCHER_ERROR_MESSAGE_403:"4. type water geen druk",
    KARCHER_ERROR_MESSAGE_404:"4. Soort water, temperatuur boven 60 ° C of externe storing",
    KARCHER_ERROR_MESSAGE_405:"Vorstbeveiliging geen druk",
    KARCHER_ERROR_MESSAGE_406:"Druk in de vorstbeveiliging ondanks uitgeschakelde antivriespomp",
    KARCHER_ERROR_MESSAGE_410:"Fout F 400 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_411:"Fout F 401 is al 300 seconden actief",
    KARCHER_ERROR_MESSAGE_412:"Fout F 402 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_413:"Fout F 403 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_414:"Fout F 405 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_420:"Foutmuntenwisselaar 1",
    KARCHER_ERROR_MESSAGE_421:"Foutmuntenwisselaar 1",
    KARCHER_ERROR_MESSAGE_440:"Geen verbinding met elektronica A31",
    KARCHER_ERROR_MESSAGE_441:"Uitgangen van de elektronica A31 overbelast",
    KARCHER_ERROR_MESSAGE_500:"Verbinding van stofzuigerelektronica 1/2",
    KARCHER_ERROR_MESSAGE_501:"Startknop van stofzuiger 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Startknop van stofzuiger 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Verbinding van stofzuigerelektronica 3/4",
    KARCHER_ERROR_MESSAGE_511:"Startknop van stofzuiger 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Startknop van stofzuiger 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Verbinding van stofzuigerelektronica 5/6",
    KARCHER_ERROR_MESSAGE_521:"Startknop van stofzuiger 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Startknop van stofzuiger 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Verbinding van stofzuigerelektronica 7/8",
    KARCHER_ERROR_MESSAGE_531:"Startknop van stofzuiger 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Startknop van stofzuiger 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Verbinding van stofzuigerelektronica 9/10",
    KARCHER_ERROR_MESSAGE_541:"Startknop van stofzuiger 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Startknop van stofzuiger 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Startknop van stofzuiger 10/11 permanent contact",
    KARCHER_ERROR_MESSAGE_551:"Startknop van stofzuiger 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Startknop van stofzuiger 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"Geen verbinding met de elektronica A30",
    KARCHER_ERROR_MESSAGE_801:"Uitgangen van de elektronica A30 overbelast",
    KARCHER_ERROR_MESSAGE_802:"Storing in onthardingsinstallatie",
    KARCHER_ERROR_MESSAGE_803:"Beschermende motorschakelaar voordrukpomp RO geactiveerd",
    KARCHER_INFO_MESSAGE_1:"De regeneratie van de basiswisselaar is gestart",
    KARCHER_INFO_MESSAGE_2:"Regeneratie van basisuitwisseling voltooid",
    KARCHER_INFO_MESSAGE_3:"Basiswisselaar leeg 75%",
    KARCHER_INFO_MESSAGE_4:"Unit niet beschikbaar vanwege technisch probleem",
    KARCHER_INFO_MESSAGE_5:"Eenheid niet beschikbaar vanwege een operationeel probleem",
    KARCHER_INFO_MESSAGE_6:"Unit is ingeschakeld",
    KARCHER_INFO_MESSAGE_10:"Hoewel het zich binnen de bedrijfsuren bevindt",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_20:"Anti-legionellaprogramma warmwatertank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionellaprogramma HD-pomp 1 vereist",
    KARCHER_INFO_MESSAGE_22:"Anti-legionellaprogramma HD-pomp 2 vereist",
    KARCHER_INFO_MESSAGE_23:"Anti-legionellaprogramma HD-pomp 3 vereist",
    KARCHER_INFO_MESSAGE_24:"Anti-legionellaprogramma HD-pomp 4 vereist",
    KARCHER_INFO_MESSAGE_25:"Anti-legionellaprogramma HD-pomp 5 vereist",
    KARCHER_INFO_MESSAGE_26:"Anti-legionellaprogramma HD-pomp 6 vereist",
    KARCHER_INFO_MESSAGE_27:"Anti-legionellaprogramma HD-pomp 7 vereist",
    KARCHER_INFO_MESSAGE_28:"Anti-legionellaprogramma HD-pomp 8 vereist",
    KARCHER_INFO_MESSAGE_29:"Anti-legionellaprogramma voltooid",
    KARCHER_INFO_MESSAGE_101:"Hogedrukpomp 1 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_102:"Hogedrukpomp 2 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_103:"Hogedrukpomp 3 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_104:"Hogedrukpomp 4 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_105:"Hogedrukpomp 5 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_106:"Hogedrukpomp 6 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_107:"Hogedrukpomp 7 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_108:"Hogedrukpomp 8 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_109:"Brander moet worden onderhouden",
    KARCHER_INFO_MESSAGE_110:"Branderblazer moet worden onderhouden",
    KARCHER_INFO_MESSAGE_111:"Warmwaterpomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_112:"Antivriespomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_113:"Osmosepomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Leidingverwarming moet worden onderhouden",
    KARCHER_INFO_MESSAGE_116:"Micro-emulsie / velg-reinigingsmiddelpomp moet worden nagekeken",
    KARCHER_INFO_MESSAGE_117:"Onderwagenreinigingspomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_118:"Systeemdrukpomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_119:"Stofzuiger 1 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_120:"Stofzuiger 2 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_121:"Stofzuiger 3 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_122:"Stofzuiger 4 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_123:"Stofzuiger 5 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_124:"Stofzuiger 6 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_125:"Stofzuiger 7 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_126:"Stofzuiger 8 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_127:"Stofzuiger 9 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_128:"Stofzuiger 10 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_129:"Stofzuiger 11 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_130:"Stofzuiger 12 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_131:"Velgenreinigingspomp moet worden nagekeken",
    KARCHER_INFO_MESSAGE_132:"Micro-emulsiepomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_133:"Intensieve schuimpomp wegens onderhoud",
    KARCHER_INFO_MESSAGE_142:"Stofzuiger 1 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_143:"Filter voor stofzuiger 1 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_144:"Stofzuiger 2 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_145:"Filter voor stofzuiger 2 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_146:"Stofzuiger 3 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_147:"Filter voor stofzuiger 3 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_148:"Stofzuiger 4 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_149:"Filter voor stofzuiger 4 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_150:"Stofzuiger 5 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_151:"Filter voor stofzuiger 5 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_152:"Stofzuiger 6 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_153:"Filter voor stofzuiger 6 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_154:"Stofzuiger 7 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_155:"Filter voor stofzuiger 7 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_156:"Stofzuiger 8 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_157:"Filter voor stofzuiger 8 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_158:"Stofzuiger 9 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_159:"Filter voor stofzuiger 9 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_160:"Stofzuiger 10 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_161:"Filter voor stofzuiger 10 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_162:"Stofzuiger 11 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_163:"Filter voor stofzuiger 11 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_164:"Stofzuiger 12 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_165:"Filter voor stofzuiger 12 moet worden onderhouden",
    ORGANIZATION:"Organisatie",
    CREATE_ORGANIZATION:"Organisatie aanmaken",
    CREATE_ORGANIZATION_AS:"Organisatie aanmaken als kind van",
    DELETE_ORGANIZATION:"Organisatie verwijderen",
    EDIT_ORGANIZATION:"Organisatie bewerken",
    SUPPORTED_ORG_NAME:"Ondersteunde organisatie",
    SUPPORTED_ORG_TYPE:"Ondersteund type",
    ORG_NAME:"Naam",
    ORG_TYPE:"Type",
    SET_ORG_TITLE:"Stel kindorganisatie in",
    SET_SUPPORTED_ORG_TITLE:"Stel ondersteunde kindorganisatie in",
    SAVE_ORGANIZATION:"Organisatie opslaan",
    SELECT_ORGANIZATION_TYPE:"Selecteer organisatietype",
    SELECT_ORGANIZATION_SELECTOR:"Selecteer",
    SELECT_SUPPORTED_ORGANIZATION:"Selecteer ondersteunde organisatie",
    ORGANIZATION_DELETED:"Organisatie succesvol verwijderd",
    ORGANIZATION_SAVED:"Organisatie succesvol opgeslagen",
    ORGANIZATION_UPDATED:"Organisatie succesvol bijgewerkt",
    ALERTS:"Meldingen",
    DEVICE_STATUS:"Apparaatstatus",
    SITE_DETAILS:"Locatiedetails",
    ALARM_STATUS:"Meldingsstatus",
    FILTER:"Filteren op ...",
    FILTER_BY_ALERT_CENTER:"Filteren op code, naam of beschrijving",
    TOTAL_ALARM:"Totaal",
    LOW_ALARM:"Evenement",
    MEDIUM_ALARM:"Storingsmelding",
    HIGH_ALARM:"Kritieke fout",
    NO_FACILITIES_NEARBY:"Er zijn geen nabijgelegen faciliteiten",
    GRAY_MAP:"Grijs gestileerde kaart",
    READY:"Gereed",
    WARNING:"Storingsmelding",
    ERROR:"Error",
    SITE_NAME:"Locatienaam",
    ACCOUNTS_INFO:"Accountinformatie",
    USER_ORGANIZATION:"Gebruikersorganisatie",
    ADD_USER_ORGANIZATION:"Nieuwe organisatiegebruiker toevoegen",
    EDIT_USER_ORGANIZATION:"Bewerk gebruikers van de organisatie",
    SELECT_ROLE:"Selecteer rol",
    SELECT_ORGANIZATION:"Selecteer organisatie",
    SELECT_USER:"Selecteer gebruiker",
    USER_FOR_ORGANIZATION_CREATED:"Nieuwe gebruiker succesvol aangemaakt",
    SELECT_REGION:"Selecteer regio",
    SELECT_LANGUAGE:"Selecteer taal",
    LOADING_DATA:"Gegevens laden, een moment geduld alstublieft ...",
    ADMINISTRATOR:"Beheerder",
    TECHNICAL_SUPPORT:"Technische ondersteuning",
    CONTROLLER:"Controller",
    EDIT_ORGANIZATION_USER:"Bewerk gebruikers van de organisatie",
    DELETE_ORGANIZATION_USER:"Verwijder gebruikers van de organisatie",
    USER_UPDATED:"Gebruiker succesvol bijgewerkt",
    USER_CREATED:"Gebruiker succesvol aangemaakt",
    ADDRESS:"Adres",
    SUBSCRIPTIONS:"Abonnementen",
    RESOLVED_STATUS:"Opgelost",
    NOT_RESOLVED_STATUS:"Niet opgelost",
    ALERT_NAME:"Meldingsnaam",
    ALERT_DESCRIPTION:"Meldingsbeschrijving",
    ALERT_CODE:"Meldingscode",
    ALERT_TYPE:"Meldingscode",
    UNSUBSCRIBE:"Melding afmelden",
    SUBSCRIBE:"Melding aanmelden",
    ALARM_SUBSCRIBED:"Succesvol aangemeld",
    UNSUBSCRIBED_CONFIRM:"Afmelden?",
    ALARM_UNSUBSCRIBED:"Succesvol afgemeld",
    ASIDE_MENU_CASHLESS_SALES:"Contactloze verkoop",
    FILTERED_CASHLESS_PAYMENTS:"Gefilterde contactloze betalingen",
    REFUND_DIALOG_TITLE:"Transactie terugbetalen?",
    REFUND_DIALOG_SUBTITLE:"Bedrag kan minder zijn dan of gelijk zijn aan transactiebedrag",
    REFUND:"Terugbetaling",
    INPUT_NOT_VALID:"Invoer is niet geldig",
    REFUND_SUCCESSFULLY:"Terugbetaling voor geselecteerde betaling is succesvol uitgevoerd",
    USER:"Gebruiker",
    TRANSACTION_ID:"PSP-referentie",
    DEVICE_ID:"Apparaat-ID",
    NET_AMOUNT:"Netto bedrag",
    TRANSACTION_STATUS:"Transactiestatus",
    REPORT_NAME:"Rapportnaam",
    TIME_FRAME:"Tijdsspanne",
    SUB_POINT:"Selecteer subpunt",
    SUB_POINT_LIST_NOT_EXIST:"Subpuntlijst bestaat niet voor geselecteerde wasfaciliteit",
    FACILITY_TYPE:"Faciliteittype",
    MACHINE_NAME:"Machinenaam",
    WASH_FACILITY_DETAILS:"Wasfaciliteit details",
    WASH_BAY_DETAILS:"Wasbaai details",
    DEVICES_INFO:"Apparaatlijst",
    OPERATION_TIME_INFO:"Bedrijfstijd",
    OPERATION_TIME_VACUUM_INFO:"Bedrijfstijd voor stofzuigers",
    OPERATION_TIME_ILLUMINATION_INFO:"Bedrijfstijd voor verlichting",
    AVAILABLE_TITLE:"Beschikbaar",
    UNAVAILABLE_TITLE:"Niet beschikbaar",
    CURRENT_PROGRAM:"Huidig programma",
    CREDITS:"Kredieten",
    DEVICE_NAME:"Apparaatnaam",
    ACTIVE_ALARMS:"Actieve meldingen",
    ALL_DAY:"De hele dag",
    OPERATING_TIME_WASH_FACILITY:"Zelfbedieningswassysteem",
    OPERATING_TIME_VACUUMS:"Stofzuigers",
    OPERATING_TIME_ILLUMINATION:"Verlichting",
    OPERATION_COUNTERS:"Bedrijfsmeters",
    EDIT:"Bewerken",
    WASHING_PROGRAMS:"Wasprogramma's",
    INFO:"Evenement",
    STATISTIC:"Statistiek",
    ROLLOVER_DOSING:"Dosering",
    ROLLOVER_SPEED:"Snelheden",
    ROLLOVER_RESETS:"Rollover reset op afstand",
    ROLLOVER_RESETS_INFO:"De reset op afstand moet in overeenstemming zijn met de lokale voorschriften. Belangrijk: Zorg ervoor dat rollover leeg is voordat u reset.",
    RESET_ROLLOVER:"Reset rollover",
    OPEN_DOOR_ROLLOVER:"Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open washal deur. Wees voorzichtig.",
    ROLLOVER_OPEN_DOOR:"Open de deur",
    APPLY_DOSING_CHANGES:"Pas doseerveranderingen toe",
    APPLY_SPEED_CHANGES:"Pas snelheidsveranderingen toe",
    ACTUATION_SUCCESS:"Verzoek verzonden",
    REMAINING_TIME:"Resterende tijd",
    OPEN_24H:"24 uur open",
    CLOSE_24H:"24 uur gesloten",
    VALIDATION_OPERATION_TIME:"Formaat niet correct. Gebruik hh:mm",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Update wasprogramma",
    UPDATE_ACTUATORS:"Update actuatoren",
    OPEN_ROLOVER_DOOR_TITLE:"Wilt u de rollover deur openen?",
    OPEN_ROLOVER_DOOR_CONTENT:"Weet u zeker dat u de deur wilt openen?",
    RESET_ROLOVER_TITLE:"Wilt u rollover resetten?",
    RESET_ROLOVER_CONTENT:"Weet u zeker dat u rollover wilt resetten?",
    G0:"{{brand === 'r2w' ? 'Baai 0' : 'Baai 1'}}",
    G1:"{{brand === 'r2w' ? 'Baai 1' : 'Baai 2'}}",
    G2:"{{brand === 'r2w' ? 'Baai 2' : 'Baai 3'}}",
    G3:"{{brand === 'r2w' ? 'Baai 3' : 'Baai 4'}}",
    G4:"{{brand === 'r2w' ? 'Baai 4' : 'Baai 5'}}",
    G5:"{{brand === 'r2w' ? 'Baai 5' : 'Baai 6'}}",
    G6:"{{brand === 'r2w' ? 'Baai 6' : 'Baai 7'}}",
    G7:"{{brand === 'r2w' ? 'Baai 7' : 'Baai 8'}}",
    G8:"{{brand === 'r2w' ? 'Baai 8' : 'Baai 9'}}",
    G9:"{{brand === 'r2w' ? 'Baai 9' : 'Baai 10'}}",
    G10:"{{brand === 'r2w' ? 'Baai 10' : 'Baai 11'}}",
    U0:"{{brand === 'r2w' ? 'Stofzuiger 0' : 'Stofzuiger 1'}}",
    U1:"{{brand === 'r2w' ? 'Stofzuiger 1' : 'Stofzuiger 2'}}",
    U2:"{{brand === 'r2w' ? 'Stofzuiger 2' : 'Stofzuiger 3'}}",
    U3:"{{brand === 'r2w' ? 'Stofzuiger 3' : 'Stofzuiger 4'}}",
    U4:"{{brand === 'r2w' ? 'Stofzuiger 4' : 'Stofzuiger 5'}}",
    U5:"{{brand === 'r2w' ? 'Stofzuiger 5' : 'Stofzuiger 6'}}",
    U6:"{{brand === 'r2w' ? 'Stofzuiger 6' : 'Stofzuiger 7'}}",
    U7:"{{brand === 'r2w' ? 'Stofzuiger 7' : 'Stofzuiger 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Meldingsrapport gemaakt door geselecteerde locatie vanuit dashboard",
    ALERT_CENTER_TITLE_BY_FACILITY:"Meldingsrapport gemaakt door geselecteerde faciliteit vanuit dashboard",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Meldingsrapport",
    ERROR_MESSAGE_403:"U hebt geen rechten om deze API-aanroep te gebruiken. Foutcode: 403",
    LAST_ACTIVE_PROGRAM:"Actief programma / Laatst actieve programma",
    PROGRAM_ID:"Programmanummer",
    PROGRAM_PRICE:"Programmaprijs",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Bijvullen vereist",
    EMPTY_CHEMICAL_LEVEL:"Leeg",
    CHEMICAL_LEVEL:"Niveau-indicatie reinigingsmiddelen (%)",
    ROLLOVER_STATUS:"Rollover status",
    ROLLOVER_STATUS_CODE_0:"Was momenteel buiten gebruik",
    ROLLOVER_STATUS_CODE_1:"Buiten bedrijfstijd",
    ROLLOVER_STATUS_CODE_2:"Programma-invoer toegestaan",
    ROLLOVER_STATUS_CODE_3:"Plaats uw voertuig",
    ROLLOVER_STATUS_CODE_4:"Voertuig vooruit",
    ROLLOVER_STATUS_CODE_5:"Voertuig achteruit",
    ROLLOVER_STATUS_CODE_6:"Voertuig stoppen",
    ROLLOVER_STATUS_CODE_7:"Was actief",
    ROLLOVER_STATUS_CODE_8:"Was gestopt",
    ROLLOVER_STATUS_CODE_9:"Was actief (tact)",
    ROLLOVER_STATUS_CODE_10:"Verlaat voertuig achteruit",
    ROLLOVER_STATUS_CODE_11:"Noodstop",
    ROLLOVER_STATUS_CODE_12:"Verlaat voertuig vooruit",
    ROLLOVER_STATUS_CODE_13:"Anti-vorst actief",
    ROLLOVER_STATUS_CODE_14:"Veiligheidsschakelaar voorkant geactiveerd",
    ROLLOVER_STATUS_CODE_15:"Veiligheidsschakelaar achterkant geactiveerd",
    ROLLOVER_STATUS_CODE_16:"Veiligheidsschakelaar linker voorkant geactiveerd",
    ROLLOVER_STATUS_CODE_17:"Veiligheidsschakelaar rechter voorkant geactiveerd",
    ROLLOVER_STATUS_CODE_18:"Veiligheidsschakelaar linker achterkant geactiveerd",
    ROLLOVER_STATUS_CODE_19:"Veiligheidsschakelaar rechter achterkant geactiveerd",
    ROLLOVER_STATUS_CODE_20:"Voertuigpositie te ver aan de linkerzijde",
    ROLLOVER_STATUS_CODE_21:"Voertuigpositie te ver aan de rechterzijde",
    ROLLOVER_STATUS_CODE_22:"Linker deur niet gesloten",
    ROLLOVER_STATUS_CODE_23:"Rechter deur niet gesloten",
    ROLLOVER_STATUS_CODE_24:"Transporter gedetecteerd, verkeerd wasprogramma geselecteerd",
    ROLLOVER_STATUS_CODE_25:"Claxonsensor",
    ROLLOVER_STATUS_CODE_98:"Handmatige / aanpassingsmodus",
    ROLLOVER_STATUS_CODE_99:"Onbekende status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Statuscode niet gedefinieerd",
    ALARM:"Kritieke fout",
    NO_ALARM:"Geen kritieke fout",
    SOFTWARE_VERSION:"Softwareversie",
    SOFTWARE_DATE:"Softwaredatum",
    SITE_ADDRESS:"Site adres",
    SECONDS:"Seconden",
    SERVICE_PART_NAME:"Servicenaam:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"bediening- en onderhoudsteller",
    OPERATION_COUNTER:"Bedieningsteller",
    SERVICE_COUNTER:"Servicecounter",
    FAULT_CODE:"Meldingscode",
    PRESSURE_TITLE:"Luchtdruk",
    TIME_TITLE:"Huidige tijd",
    COUNTRY_TITLE:"Land",
    CITY_TITLE:"Stad",
    REGION_TITLE:"Regio",
    SELECT_POINTS_TO_SEARCH:"Selecteer punten ...",
    LOGS_HISTORY:"Parameterwijzigingsgeschiedenis",
    ACTUATOR_REFERENCE:"Actuatorreferentie",
    ACTUATOR_VALUE:"Actuatorwaarde",
    POINT_ID:"Punt-ID",
    VALIDATION_NOT_VALID_RANGE:"Onjuiste reeks",
    ENABLE_ROLLOVER_RESET:"Door dit vakje aan te vinken bevestigt u dat u de veiligheidsinstructies hebt gelezen en ermee akkoord gaat.",
    CHANGE_OF_PARAMETERS:"Wijziging van parameters",
    SELECT_OPTIONS:"Selecteer opties",
    AUTOMATIC:"Automatisch",
    DESALTING:"Ontzoutingsfunctie",
    SEASON_WASH:"Seizoen wasprogramma's",
    SPRING_PROGRAM:"Lente wasprogramma's",
    SUMMER_PROGRAM:"Zomer wasprogramma's",
    AUTUMN_PROGRAM:"Herfst wasprogramma's",
    WINTER_PROGRAM:"Winter wasprogramma's",
    DOOR_CONTROL:"Deurbediening",
    SUMMER_DOOR_CONTROL:"Zomer, bediend met de poortbediening in zomermodus",
    WINTER_DOOR_CONTROL:"Winter, bediend met de poortbediening in wintermodus",
    APPLY_PARAMETERS_CHANGES:"Pas parameterwijzigingen toe",
    WORKING_SCHEDULES:"Werkroosters",
    HOLIDAY_SCHEDULES:"Vakantieschema's",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Vakanties op locatie succesvol aangemaakt",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Vakanties op locatie succesvol bijgewerkt",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Vakanties op locatie succesvol verwijderd",
	WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Werkroosters op locatie succesvol bijgewerkt",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Werkroosters succesvol verspreid",
    HOLIDAY_SUCCESSFULLY_DELETED:"Vakantie succesvol verwijderd",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Droogmiddel met laag vulniveau",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoo met laag vulniveau",
    CHEM_LEVEL_LOW_FOAM:"Schuim met laag vulniveau",
    CHEM_LEVEL_LOW_WAX_1:"Was met laag vulniveau",
    CHEM_LEVEL_LOW_POLISH_1:"Polish met laag vulniveau",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Velgenreiniger met laag vulniveau",
    CHEM_LEVEL_LOW_WAX_2:"Was met laag vulniveau",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Bandenglans met laag vulniveau",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insectenverwijderaar met laag vulniveau",
    CHEM_LEVEL_LOW_POLISH_2:"Polish met laag vulniveau",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensief met laag vulniveau",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Schuimregen met laag vulniveau",
    CHEM_LEVEL_DRYING_AGENT:"Vulniveau droogmiddel",
    CHEM_LEVEL_SHAMPOO:"Vulniveau shampoo",
    CHEM_LEVEL_FOAM:"Vulniveau schuim",
    CHEM_LEVEL_WAX_1:"Vulniveau was",
    CHEM_LEVEL_POLISH_1:"Vulniveau polish",
    CHEM_LEVEL_RIM_CLEANER:"Vulniveau velgenreiniger",
    CHEM_LEVEL_WAX_2:"Vulniveau was",
    CHEM_LEVEL_TYRE_SHINE:"Vulniveau bandenglans",
    CHEM_LEVEL_INSECT_REMOVER:"Vulniveau insectenverwijderaar",
    CHEM_LEVEL_POLISH_2:"Vulniveau polish",
    CHEM_LEVEL_INTENSIVE:"Vulniveau intensief",
    CHEM_LEVEL_FOAM_RAIN:"Vulniveau schuimregen",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servicebalie dakborstel hijsband",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servicebalie droger hijsband",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servicebalie motorkabel dakborstel",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servicebalie zoetwaterpomp onderhoud",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servicebalie pomp onderhoud gebruikt water",
    DRYING_AGENT:"Droogmiddel",
    FOAM_DRYING_AGENT:"Schuim droogmiddel",
    SHAMPOO:"Shampoo",
    FOAM:"Schuim",
    BRUSH_FOAM:"Brush foam",
    WAX_1:"Was",
    FOAM_WAX_1:"Schuim was",
    POLISH_1:"Polish",
    RIM_CLEANING:"Velgenreiniger",
    WAX_2:"Was",
    FOAM_WAX_2:"Schuim was",
    TYRE_SHINE:"Bandenglans",
    INSECT_REMOVER:"Insectenverwijderaar",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensief basis",
    INTENSIVE_SIDE:"Intensieve zijde",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensieve dak spray bar",
    TAR_REMOVER:"Teer verwijderaar",
    UNDER_CHASSIS_CONVERSATION:"Onderstel gesprek",
    STATIONARY_PRE_SPRAY_ARCH:"Stationaire voor-spray boog",
    FOAM_RAIN:"Schuimregen",
    PRE_CLEANING:"Voorreiniging",
    BRUSH:"Borstel",
    CARE:"Verzorging",
    DRYING:"Drogen",
    DRYING_LOW_NOISE:"Drogen met verminderd geluid",
    INTENSIVE_CLEANING:"Intensieve reiniging",
    BRUSH_CLEANING:"Borstels reinigen",
    EMPTY_RUN:"Lege run",
    DRYING_AID:"Drooghulp",
    WAX:"Was",
    FOAM_WASH:"Schuimwas",
    POLISH:"Polish",
    FOAM_POLISH:"Schuim polish",
    WHEEL_CLEANING:"Wielen reinigen",
    HIGH_PRESSURE_ROOF:"Dak hoge druk",
    HIGH_PRESSURE_SIDE:"Zijkant hoge druk",
    DRYER_FORWARD:"Droger vooruit",
    DRYER_BACKWARD:"Droger achteruit",
    DELETE_ALL_HOLIDAYS:" Verwijder alle feestdagen voor geselecteerde locatie",
    CREATE_NEW_HOLIDAY:"Maak nieuw",
    RESET_INPUTS:"Reset alle feestdagen invoer",
    TWENTY_FOUR_HOURS_OPEN:"24 uur open",
    EVERY_YEAR:"Jaarlijks",
    DELETE_HOLIDAY:"Verwijder feestdag",
    ADD_NEW_HOLIDAY:"Voeg nieuwe feestdag toe",
    HOLIDAYS_LIST:"Lijst van bestaande feestdagen",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Verwijder alle feestdagen voor geselecteerde locatie?",
    VALIDATION_HOLIDAY_DATE:"Formaat niet correct. Gebruik mm-dd",
    FOR_DATE:"Voor datum",
    WITH_ID:"Met ID",
    FROM_HOURS:"Van (u)",
    FROM_MINUTES:"Van (min)",
    TO_HOURS:"Tot (u)",
    TO_MINUTES:"Tot (min)",
    NOT_MATCH:"Komt niet overeen",
    START:"Van",
    STOP:"Tot",
    DAILY_TIME:"24 uur lijst",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuele tijdinstelling",
    PROGRAM_NOT_STARTED:"Programma nog niet gestart",
    JETWASH:"Zelfbedieningswassysteem",
    KARCHER_REPORT_1:"Rollover: Omzetindicatie per programma en in totaal",
    KARCHER_REPORT_2:"Rollover: Gestarte wasbeurten per programma en in totaal",
    KARCHER_REPORT_3:"Rollover: Uitgevoerde wasbeurten per programma en in totaal",
    KARCHER_REPORT_4:"Rollover: Aantal gestarte wasbeurten via betaalterminal per programma en in totaal",
    KARCHER_REPORT_5:"Rollover: Aantal handmatig gestarte wasbeurten per programma en in totaal",
    KARCHER_REPORT_6:"Rollover: Aantal geannuleerde wasbeurten per programma en in totaal",
    KARCHER_REPORT_7:"Rollover: Aantal stroomstoringen",
    KARCHER_REPORT_8:"SB-Units: Aantal uren per wasprogramma gefilterd per baai en in totaal",
    KARCHER_REPORT_9:"SB-Units: Omzetindicatie per wasbaai en in totaal",
    KARCHER_REPORT_10:"SB-Units: Token/Munten teller per muntkanaal",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Zoetwaterpomp",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Proceswaterpomp",
    OPERATION_COUNTER_HP_PUMP_1:"Hogedrukpomp 1",
    OPERATION_COUNTER_HP_PUMP_2:"Hogedrukpomp 2",
    RELEASE_NOTES:"App-versies en release-opmerkingen",
    BACKEND_RELEASE_NOTES:"Platform release-opmerkingen:",
    FRONTEND_RELEASE_NOTES:"Webapplicatie release-opmerkingen:",
    SELECTED_FACILITY_TIMEZONE:"Tijdzone voor geselecteerde faciliteit:",
    REFRESH_PAGE:"Vernieuw pagina",
    REFRESH_MAPS:"Vernieuw kaarten",
    PUMPS:"Pompen",
    RUN_TIME:"Looptijd",
    RUN_TIME1:"Looptijd 1",
    RUN_TIME2:"Looptijd 2",
    PROGRAM_RUNTIME_ACTUATOR:"Actuator voor looptijd",
    PROGRAM_RUNTIME_ACTUATOR_1:"Actuator voor looptijd 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Actuator voor looptijd 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimale waarde is 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maximale waarde is 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Gebruik prijsformaat x.xx",
    ACTUATION_NOT_ALLOWED:"Actuatie niet toegestaan voor huidige gebruikersrol",
    MAINTENANCE_DAYS:"Onderhoudsdagen",
    MAINTENANCE_WASHES:"Onderhoudsbeurten",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Totaal inkomen POS",
    PROPAGATE:"Verspreiden",
    ALL_DAY_HOURS_SELECTOR:"24-uurs type selector",
    GET_OPERATING_TIME_FROM_SITE:"Haal bedrijfstijd van huidig apparaat uit werkschema's van de site",
    USER_NOT_VALID:"Gebruiker is niet geldig. Probeer met andere accountgegevens.",
    VERIFIED:"Geverifieerd",
    RESEND_VERIFICATION_MAIL:"Verificatie-e-mail opnieuw verzenden",
    RETURN_TO_DASHBOARD:"Terug naar dashboard",
    ERROR_PAGE_BAD_REQUEST:"400 Foutieve aanvraag.",
    WASHES:"Aantal wasbeurten",
    TIME_TO_SERVICE:"Tijd tot onderhoud",
    ACCOUNT_ALREADY_ACTIVATED:"Account al geactiveerd",
    DEVICE_EVENTS:"Apparatuurevenementen",
    DEVICE_EVENTS_LOG_PULLED:"Opgevraagd evenementenlogboek voor apparaat",
    EVENTS_PULL_DATE:"Opgevraagde evenementen tijd",
    DEVICE_EVENTS_REFRESH:"Nieuwe evenementgegevens ophalen",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Websockets verbindingsprobleem. Probeer de pagina te verversen.",
    INSTALLATION_DATE:"Installatiedatum van de machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Heet wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Hoge druk reiniging",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim schuim",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Power schuim",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Schuimwas HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Was",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Topverzorging",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Schuim was",
    POLISH1:"Polish",
    WAX1:"Was",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Sitegegevens succesvol bijgewerkt",
    COMPANY:"Bedrijf",
    FACILITY_HAS_CHANGER:"Heeft u een wisselaar?",
    DISABLE_OFFLINE_ALARM:"R2W-alarmen uitschakelen",
    ASIDE_WORKING_SCHEDULES:"App-sitegegevens",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash servicevoorwaarden",
    TERMS_OF_SERVICE_R2W:"Ready2Wash servicevoorwaarden",
    DATA_PROCESSING_TITLE:"Gegevens verwerkt",
    PRIVACY_POLICY_TITLE:"Privacybeleid",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay servicevoorwaarden",
    TERMS_AND_SERVICES:"Voorwaarden en diensten",
    HOURLY: "Elk uur",
    DAILY: "Dagelijks",
    WEEKLY: "Wekelijks",
    MONTHLY: "Maandelijks",
    YEARLY: "Jaarlijks",
    DELETE_ITEM_SUCCESS:"U heeft het item succesvol verwijderd",
    STATE: "Staat",
    AVAILABILITY_STATUS_1: "Eenheid open",
    AVAILABILITY_STATUS_2: "Eenheid gesloten (vakantie)",
    AVAILABILITY_STATUS_3: "Eenheid gesloten (openingstijden)",
    AVAILABILITY_STATUS_4: "Eenheid gesloten (storing)",
    AVAILABILITY_STATUS_5: "Eenheid gesloten (overig)",
    AVAILABILITY_VACUUMS_STATUS_1: "Stofzuigers niet geïnstalleerd",
    AVAILABILITY_VACUUMS_STATUS_2: "Stofzuigers open",
    AVAILABILITY_VACUUMS_STATUS_3: "Stofzuigers gesloten (vakantie)",
    AVAILABILITY_VACUUMS_STATUS_4: "Stofzuigers gesloten (openingstijden)",
    AVAILABILITY_VACUUMS_STATUS_5: "Stofzuigers gesloten (storing)",
    AVAILABILITY_VACUUMS_STATUS_6: "Stofzuigers gesloten (overig)",
    ECOM_AMOUNT: "Totale Ecom voor alle locaties",
    CAPTURED: "Gevangen",
    DELETE_COMPANY_HISTORY_INFO:"Deze actie verwijdert alle rapportgegevens van uw bedrijf. Deze actie kan niet ongedaan worden gemaakt.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Weet u zeker dat u alle rapportgegevens permanent wilt verwijderen?",
    VALUE_DATE: "Waardedatum",
    KARCHER_EVENT_NAME_1: "Basis warmtewisselaar geregenereerd",
    KARCHER_EVENT_NAME_2: "Regeneratie van de basis warmtewisselaar voltooid",
    KARCHER_EVENT_NAME_3: "Materiaal / serienummer",
    KARCHER_EVENT_NAME_4: "Het systeem is gedesinfecteerd",
    KARCHER_EVENT_NAME_5: "HP-pomp 1 gedesinfecteerd",
    KARCHER_EVENT_NAME_6: "HP-pomp 2 gedesinfecteerd",
    KARCHER_EVENT_NAME_7: "HP-pomp 3 gedesinfecteerd",
    KARCHER_EVENT_NAME_8: "HP-pomp 4 gedesinfecteerd",
    KARCHER_EVENT_NAME_9: "HP-pomp 5 gedesinfecteerd",
    KARCHER_EVENT_NAME_10: "Waspunt 1 vergrendeld",
    KARCHER_EVENT_NAME_11: "Waspunt 2 vergrendeld",
    KARCHER_EVENT_NAME_12: "Waspunt 3 vergrendeld",
    KARCHER_EVENT_NAME_13: "Waspunt 4 vergrendeld",
    KARCHER_EVENT_NAME_14: "Waspunt 5 vergrendeld",
    KARCHER_EVENT_NAME_15: "Waspunt 6 vergrendeld",
    KARCHER_EVENT_NAME_16: "Waspunt 7 vergrendeld",
    KARCHER_EVENT_NAME_17: "Waspunt 8 vergrendeld",
    KARCHER_EVENT_NAME_18: "Update gestart",
    KARCHER_EVENT_NAME_19: "Update voltooid",
    KARCHER_EVENT_NAME_20: "WS Reg start",
    KARCHER_EVENT_NAME_21: "WS Reg einde",
    KARCHER_EVENT_NAME_22: "WS 75%-sensor",
    KARCHER_EVENT_NAME_23: "Technische storing",
    KARCHER_EVENT_NAME_24: "Bedrijfsstoring",
    KARCHER_EVENT_NAME_25: "Eenheid ingeschakeld",
    KARCHER_EVENT_NAME_26: "Eenheid uitgeschakeld",
    KARCHER_EVENT_NAME_27: "Doos 1 gesloten",
    KARCHER_EVENT_NAME_28: "Doos 2 gesloten",
    KARCHER_EVENT_NAME_29: "Doos 3 gesloten",
    KARCHER_EVENT_NAME_30: "Doos 4 gesloten",
    KARCHER_EVENT_NAME_31: "Doos 5 gesloten",
    KARCHER_EVENT_NAME_32: "Doos 6 gesloten",
    KARCHER_EVENT_NAME_33: "Doos 7 gesloten",
    KARCHER_EVENT_NAME_34: "Doos 8 gesloten",
    KARCHER_EVENT_NAME_35: "HP-pomppunt 1",
    KARCHER_EVENT_NAME_36: "HP-pomppunt 2",
    KARCHER_EVENT_NAME_37: "HP-pomppunt 3",
    KARCHER_EVENT_NAME_38: "HP-pomppunt 4",
    KARCHER_EVENT_NAME_39: "HP-pomppunt 5",
    KARCHER_EVENT_NAME_40: "HP-pomppunt 6",
    KARCHER_EVENT_NAME_41: "HP-pomppunt 7",
    KARCHER_EVENT_NAME_42: "HP-pomppunt 8",
    KARCHER_EVENT_NAME_43: "Brander",
    KARCHER_EVENT_NAME_44: "Ventilator van de brander",
    KARCHER_EVENT_NAME_45: "Warmwaterpomp",
    KARCHER_EVENT_NAME_46: "Vorstbeschermingspomp",
    KARCHER_EVENT_NAME_47: "Osmosepomp",
    KARCHER_EVENT_NAME_48: "Vloerverwarming",
    KARCHER_EVENT_NAME_49: "Slangverwarming",
    KARCHER_EVENT_NAME_50: "Micro-/velgenreiniging",
    KARCHER_EVENT_NAME_51: "Onderstel waspomp",
    KARCHER_EVENT_NAME_52: "Schuimpompbooster",
    KARCHER_EVENT_NAME_53: "Stofzuiger 1",
    KARCHER_EVENT_NAME_54: "Stofzuiger 2",
    KARCHER_EVENT_NAME_55: "Stofzuiger 3",
    KARCHER_EVENT_NAME_56: "Stofzuiger 4",
    KARCHER_EVENT_NAME_57: "Stofzuiger 5",
    KARCHER_EVENT_NAME_58: "Stofzuiger 6",
    KARCHER_EVENT_NAME_59: "Stofzuiger 7",
    KARCHER_EVENT_NAME_60: "Stofzuiger 8",
    KARCHER_EVENT_NAME_61: "Stofzuiger 9",
    KARCHER_EVENT_NAME_62: "Stofzuiger 10",
    KARCHER_EVENT_NAME_63: "Stofzuiger 11",
    KARCHER_EVENT_NAME_64: "Stofzuiger 12",
    KARCHER_EVENT_NAME_65: "Velgreinigingspomp",
    KARCHER_EVENT_NAME_66: "Micro pomp",
    KARCHER_EVENT_NAME_67: "Intensieve pomp",
    KARCHER_EVENT_NAME_68: "Turbine stofzuiger 1",
    KARCHER_EVENT_NAME_69: "Filter stofzuiger 1",
    KARCHER_EVENT_NAME_70: "Turbine stofzuiger 2",
    KARCHER_EVENT_NAME_71: "Filter stofzuiger 2",
    KARCHER_EVENT_NAME_72: "Turbine stofzuiger 3",
    KARCHER_EVENT_NAME_73: "Filter stofzuiger 3",
    KARCHER_EVENT_NAME_74: "Turbine stofzuiger 4",
    KARCHER_EVENT_NAME_75: "Filter stofzuiger 4",
    KARCHER_EVENT_NAME_76: "Turbine stofzuiger 5",
    KARCHER_EVENT_NAME_77: "Filter stofzuiger 5",
    KARCHER_EVENT_NAME_78: "Turbine stofzuiger 6",
    KARCHER_EVENT_NAME_79: "Filter stofzuiger 6",
    KARCHER_EVENT_NAME_80: "Turbine stofzuiger 7",
    KARCHER_EVENT_NAME_81: "Filter stofzuiger 7",
    KARCHER_EVENT_NAME_82: "Turbine stofzuiger 8",
    KARCHER_EVENT_NAME_83: "Filter stofzuiger 8",
    KARCHER_EVENT_NAME_84: "Turbine stofzuiger 9",
    KARCHER_EVENT_NAME_85: "Filter stofzuiger 9",
    KARCHER_EVENT_NAME_86: "Turbine stofzuiger 10",
    KARCHER_EVENT_NAME_87: "Filter stofzuiger 10",
    KARCHER_EVENT_NAME_88: "Turbine stofzuiger 11",
    KARCHER_EVENT_NAME_89: "Filter stofzuiger 11",
    KARCHER_EVENT_NAME_90: "Turbine stofzuiger 12",
    KARCHER_EVENT_NAME_91: "Filter stofzuiger 12",
    INSERT_TOKEN: "Voer tokens in en start de service",
    OPEN_SESSION: "Sessie succesvol geopend",
    IN_PROGRESS: "Bezig ...",
    TOKEN_INSERTED: "Tokens succesvol ingevoerd",
    EXPIRED_SESSION: "Sessie verlopen",
    TWO_DIGIT_INTEGER_VALIDATION: "Gebruik maximaal een tweecijferig geheel getal",
    KARCHER_OPERATION_COUNTER_1: "Wasstation 1 HP-pomp",
    KARCHER_OPERATION_COUNTER_2: "Wasstation 1 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_3: "Wasstation 1 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_4: "Wasstation 1 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_5: "Wasstation 1 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_6: "Wasstation 2 HP-pomp",
    KARCHER_OPERATION_COUNTER_7: "Wasstation 2 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_8: "Wasstation 2 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_9: "Wasstation 2 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_10: "Wasstation 2 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_11: "Wasstation 3 HP-pomp",
    KARCHER_OPERATION_COUNTER_12: "Wasstation 3 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_13: "Wasstation 3 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_14: "Wasstation 3 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_15: "Wasstation 3 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_16: "Wasstation 4 HP-pomp",
    KARCHER_OPERATION_COUNTER_17: "Wasstation 4 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_18: "Wasstation 4 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_19: "Wasstation 4 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_20: "Wasstation 4 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_21: "Wasstation 5 HP-pomp",
    KARCHER_OPERATION_COUNTER_22: "Wasstation 5 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_23: "Wasstation 5 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_24: "Wasstation 5 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_25: "Wasstation 5 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_26: "Wasstation 6 HP-pomp",
    KARCHER_OPERATION_COUNTER_27: "Wasstation 6 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_28: "Wasstation 6 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_29: "Wasstation 6 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_30: "Wasstation 6 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_31: "Wasstation 7 HP-pomp",
    KARCHER_OPERATION_COUNTER_32: "Wasstation 7 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_33: "Wasstation 7 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_34: "Wasstation 7 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_35: "Wasstation 7 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_36: "Wasstation 8 HP-pomp",
    KARCHER_OPERATION_COUNTER_37: "Wasstation 8 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_38: "Wasstation 8 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_39: "Wasstation 8 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_40: "Wasstation 8 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosepomp",
    KARCHER_OPERATION_COUNTER_42: "Warmwatergenerator",
    KARCHER_OPERATION_COUNTER_43: "Antivriespomp",
    KARCHER_OPERATION_COUNTER_44: "WSO-filterpatronen",
    KARCHER_OPERATION_COUNTER_45: "Verwarmingspomp voor wasstation",
    KARCHER_OPERATION_COUNTER_46: "Warmwaterpomp",
    KARCHER_OPERATION_COUNTER_47: "Slangverwarming voor schuim",
    KARCHER_OPERATION_COUNTER_48: "Wielwaspomp",
    KARCHER_OPERATION_COUNTER_49: "Micro-emulsiepomp",
    KARCHER_OPERATION_COUNTER_50: "Intensieve schuimpomp",
    KARCHER_OPERATION_COUNTER_51: "Stofzuiger 1 turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Stofzuiger 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Stofzuiger 1 turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Stofzuiger 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Stofzuiger 2 turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Stofzuiger 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Stofzuiger 2 turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Stofzuiger 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Stofzuiger 3 turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Stofzuiger 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Stofzuiger 3 turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Stofzuiger 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Stofzuiger 4 turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Stofzuiger 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Stofzuiger 4 turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Stofzuiger 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Stofzuiger 5 turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Stofzuiger 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Stofzuiger 5 turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Stofzuiger 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Stofzuiger 6 turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Stofzuiger 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Stofzuiger 6 turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Stofzuiger 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Condenswater uit de compressor verwijderen",
    KARCHER_OPERATION_COUNTER_76: "Controleer antivriessysteem",
    KARCHER_OPERATION_COUNTER_77: "Ventilator van brander",
    KARCHER_OPERATION_COUNTER_78: "Schuimversterkingspomp",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "De gegevenslijst is groter dan 10000 items",
    KARCHER_POINT_NAME_1: "Feestdag",
    KARCHER_POINT_NAME_2: "Maandag",
    KARCHER_POINT_NAME_3: "Dinsdag",
    KARCHER_POINT_NAME_4: "Woensdag",
    KARCHER_POINT_NAME_5: "Donderdag",
    KARCHER_POINT_NAME_6: "Vrijdag",
    KARCHER_POINT_NAME_7: "Zaterdag",
    KARCHER_POINT_NAME_8: "Zondag",
    KARCHER_POINT_NAME_9: "Stofzuigers Feestdag",
    KARCHER_POINT_NAME_10: "Stofzuigers Maandag",
    KARCHER_POINT_NAME_11: "Stofzuigers Dinsdag",
    KARCHER_POINT_NAME_12: "Stofzuigers Woensdag",
    KARCHER_POINT_NAME_13: "Stofzuigers Donderdag",
    KARCHER_POINT_NAME_14: "Stofzuigers Vrijdag",
    KARCHER_POINT_NAME_15: "Stofzuigers Zaterdag",
    KARCHER_POINT_NAME_16: "Stofzuigers Zondag",
    KARCHER_POINT_NAME_17: "Verlichting Feestdag",
    KARCHER_POINT_NAME_18: "Verlichting Maandag",
    KARCHER_POINT_NAME_19: "Verlichting Dinsdag",
    KARCHER_POINT_NAME_20: "Verlichting Woensdag",
    KARCHER_POINT_NAME_21: "Verlichting Donderdag",
    KARCHER_POINT_NAME_22: "Verlichting Vrijdag",
    KARCHER_POINT_NAME_23: "Verlichting Zaterdag",
    KARCHER_POINT_NAME_24: "Verlichting Zondag",
    KARCHER_POINT_NAME_25: "Programma 0",
    KARCHER_POINT_NAME_26: "Programma 1",
    KARCHER_POINT_NAME_27: "Programma 2",
    KARCHER_POINT_NAME_28: "Programma 3",
    KARCHER_POINT_NAME_29: "Programma 4",
    KARCHER_POINT_NAME_30: "Programma 5",
    KARCHER_POINT_NAME_31: "Programma 6",
    KARCHER_POINT_NAME_32: "Programma 7",
    KARCHER_POINT_NAME_33: "Programma 8",
    KARCHER_POINT_NAME_34: "Programma 9",
    KARCHER_POINT_NAME_35: "Programma 10",
    KARCHER_POINT_NAME_36: "Programma 11",
    KARCHER_POINT_NAME_37: "Programma 12",
    KARCHER_POINT_NAME_38: "Programma 13",
    KARCHER_POINT_NAME_39: "Programma 14",
    KARCHER_POINT_NAME_40: "Programma 15",
    KARCHER_POINT_NAME_41: "Programma 16",
    KARCHER_POINT_NAME_42: "Programma 17",
    KARCHER_POINT_NAME_43: "Programma 18",
    KARCHER_POINT_NAME_44: "Programma 19",
    KARCHER_POINT_NAME_45: "Programma 20",
    KARCHER_POINT_NAME_46: "Programma 21",
    KARCHER_POINT_NAME_47: "Programma 22",
    KARCHER_POINT_NAME_48: "Programma 23",
    KARCHER_POINT_NAME_49: "Programma 24",
    KARCHER_POINT_NAME_50: "Programma 25",
    KARCHER_POINT_NAME_51: "Programma 26",
    KARCHER_POINT_NAME_52: "Programma 27",
    KARCHER_POINT_NAME_53: "Programma 28",
    KARCHER_POINT_NAME_54: "Programma 29",
    KARCHER_POINT_NAME_55: "Programma 30",
    KARCHER_POINT_NAME_56: "Programma 31",
    KARCHER_POINT_NAME_57: "Programma 32",
    QR_CODE: "QR-code",
    ACCEPT_TERMS_AND_CONDITIONS: "Accepteer algemene voorwaarden",
    CREATE_AND_PRINT_VOUCHERS: "Maak en print waardebonnen",
    CODE_PREFIX_QUESTION: "Codevoorvoegsel is niet ingevoerd",
    CODE_PREFIX_QUESTION_TEXT: "Wilt u doorgaan zonder codevoorvoegsel?",
    ISSUED_DATE: "Uitgiftedatum",
    VOUCHER_VALIDITY_DAYS: "Geldigheid waardebon (dagen)",
    IDENTIFICATION_CODE: "Identificatiecode",
    VALIDATION_ONLY_NUMBERS: "Alleen nummers zijn toegestaan",
    REPRINT_VOUCHERS: "Kopie van waardebonnen afdrukken",
    EXPIRY_DATE: "Geldig tot",
    VOUCHER_TYPE_VACUUM: "Bon voor: Stofzuiger",
    VOUCHER_TYPE_JETWASH: "Bon voor: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Bon voor: Matt"
  });
})();
